import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { filterSingleDate_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSingleDate_template";
import { filterAutocomplete_template } from "./filterAutocomplete_template";
import { DragAndDropHandler } from "../../utils/DragAndDropHandler";
import { infoButton_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";
import { tagTypFieldEdit_template } from "./tagTypFieldEdit_template";
import { imageWidget_template } from "./imageWidget_template";
import { Locale } from "../../utils/types/locale";

import { imagePickerHelper } from "../../../vendor/valnet/valnet_imagePicker/js/modules/imagePickerHelper";
import {
  countryCodeFilter,
  streamRentBuyFilter,
} from "../../utils/AffiliateLinkHelper";
import { vignettePreview_template } from "./vignettePreview_template";
import { emaki_tag_type } from "../../utils/types/tag_type";
import { SPEC_NAME_POPUP_EDIT } from "../../utils/consts/tag_spec_type";
import { Spec, Tag } from "../../utils/types/tag";
import { getBrandInfoFromVnAppZone } from "../../utils/BrandHelper";
import { userHasPermissions } from "../../utils/PermissionsHelper";
import { PermissionCheck } from "../../utils/types/permission";
import LocaleHandler from "../../utils/LocaleHandler";
import TagDefaultsHelper from "../../utils/TagDefaultsHelper";

declare var ko: any;
declare var CKEDITOR: any;
let tagDescriptionEditor;

const newSpecProperties = {
  dataType: "text",
  disabled: false,
  fieldId: null,
  isAdded: false,
  isForcedOverwrite: null,
  label: null,
  restriction: null,
  value: null,
};

export class tagPickerEdit_template extends vnTemplate {
  public filterAffiliates: filterAutocomplete_template;
  public filterLocales: filterAutocomplete_template;
  public linkExpirationDatePicker: filterSingleDate_template;
  public filterEditTagType: filterAutocomplete_template;
  protected automaticPricingTooltip: infoButton_template;
  public imageWidgetForTagImage: imageWidget_template;
  public imageWidgetForTagImageGroup: imageWidget_template;
  public tagTypeFieldEdit: tagTypFieldEdit_template;
  public imageWidgetForTagIconImage: imageWidget_template;
  public imageWidgetForTagBannerImage: imageWidget_template;
  protected automaticPricingTooltipContent;
  protected parent: any;
  protected selectableTagsEditPageTooltip: infoButton_template;
  protected selectableTagsEditPageTooltipContent;
  public imagePickerHelper: imagePickerHelper;
  public vignetteFilter: filterAutocomplete_template;
  public vignettePreview: vignettePreview_template;
  public defaultVignetteFilter: filterAutocomplete_template;
  public defaultVignettePreview: vignettePreview_template;
  public reviewScoreEmbargoEndDate: filterSingleDate_template;
  protected localeHandler: LocaleHandler;
  protected idBrand: number;
  protected locales: Locale[] = [];

  protected getTemplateHtml(): string {
    return /*html*/ `
            <div class="w-picker-form form-edit" id="tag-picker-edit" data-bind="css: { 'is-visible': isShown }">
                <div class="picker-form">
                    <div class="form-header w-justify">
                        <div class="w-left"></div>
                        <div class="w-center">
                            <div class="section-title">
                                <h3 class="section-title">Edit tag</h3>
                            </div>
                        </div>
                        <div class="w-right">
                            <button type="button" class="close-btn icon i-close" data-bind="event: { click: onClickCancel.bind($data) }"></button>
                        </div>
                    </div>

                    <div class="form-body" >
                        <div class="tag-header">
                            <div class="tag-header-left" style="width:30rem">
                                <div class="form-group">
                                    <div class="d-inline-flex align-center" style="flex-wrap:wrap; margin-bottom:1rem;">
                                        <!-- ko ifnot: isBrandOwner() -->
                                        ${TagDefaultsHelper.getUseTagDefaultHtml(
                                          "image"
                                        )}
                                        <!-- /ko -->
                                        <label style="display:inline-block; margin-bottom:0" class="form-label icon i-brand-filled"
                                            data-bind="css: { 'default-value': isBrandOwner() || useTagDefaults().image}"
                                        >
                                            Image
                                        </label>
                                    </div>
                                    <!-- ko if: isBrandOwner() -->
                                        <div class="w-img">
                                            <div class="d-inline-flex align-center" style="width:100%; gap:4px;">
                                                <button class="btn icon i-image only-icon" type="button" data-bind="event: { click: onClickEditImage }" ></button>
                                                <!-- ko if: tagDefaults().image !== null -->
                                                <button class="btn icon i-delete only-icon" data-bind="event: { click: onClickclearImage }"></button>
                                                <!-- /ko -->
                                            </div>
                                            <!-- ko if: tagDefaults().image !== null -->
                                                <img data-bind="attr: {src: tagDefaults().image.url }">
                                            <!-- /ko -->
                                        </div>
                                    <!-- /ko -->
                                    <!-- ko ifnot: isBrandOwner() -->
                                        <!-- ko ifnot: useTagDefaults().image -->
                                            <div class="w-img">
                                                <div class="d-inline-flex align-center" style="width:100%; gap:4px;">
                                                    <button class="btn icon i-image only-icon" type="button" data-bind="event: { click: onClickEditImage }" ></button>
                                                    <!-- ko if: image() != null -->
                                                    <button class="btn icon i-delete only-icon" data-bind="event: { click: onClickclearImage }"></button>
                                                    <!-- /ko -->
                                                </div>
                                                <!-- ko if: image() !== null -->
                                                    <img data-bind="attr: {src: image().url  }" style:"width: 10rem;">
                                                <!-- /ko -->
                                            </div>
                                        <!-- /ko -->
                                    <!-- /ko -->
                                </div>

                               <div class="form-group">
                                    <div class="d-inline-flex align-center" style="flex-wrap:wrap; margin-bottom:1rem;">
                                        <!-- ko ifnot: isBrandOwner() -->
                                            ${TagDefaultsHelper.getUseTagDefaultHtml(
                                              "iconImage"
                                            )}
                                        <!-- /ko -->
                                        <label style="display:inline-block; margin-bottom:0" class="form-label icon i-brand-filled"
                                            data-bind="css: { 'default-value': isBrandOwner() || useTagDefaults().iconImage }"
                                        >
                                            Icon
                                        </label>
                                    </div>
                                    <!-- ko if: isBrandOwner() -->
                                        <div class="w-img icon-img">
                                             <div class="d-inline-flex align-center" style="width:100%; gap:4px;">
                                                <button class="btn icon i-brand-filled only-icon" type="button" data-bind="event: { click: onClickEditIconImage }" ></button>
                                                <!-- ko if: tagDefaults().iconImage !== null -->
                                                    <button class="btn icon i-delete only-icon" data-bind="event: { click: onClickclearIconImage }"></button>
                                                <!-- /ko -->
                                            </div>
                                            <!-- ko if: tagDefaults().iconImage !== null -->
                                                <img data-bind="attr: {src: tagDefaults().iconImage.url }" style:"width: 10rem;">
                                            <!-- /ko -->
                                        </div>
                                    <!-- /ko -->
                                    <!-- ko ifnot: isBrandOwner() -->
                                        <!-- ko ifnot: useTagDefaults().iconImage -->
                                            <div class="w-img icon-img">
                                                <div class="d-inline-flex align-center" style="width:100%; gap:4px;">
                                                    <button class="btn icon i-brand-filled only-icon" type="button" data-bind="event: { click: onClickEditIconImage }" ></button>
                                                    <!-- ko if: iconImage() != null -->
                                                    <button class="btn icon i-delete only-icon" data-bind="event: { click: onClickclearIconImage }"></button>
                                                    <!-- /ko -->
                                                </div>
                                                <!-- ko if: iconImage() != null -->
                                                    <img data-bind="attr: {src: iconImage().url }" style:"width: 10rem;">
                                                <!-- /ko -->
                                            </div>
                                        <!-- /ko -->
                                    <!-- /ko -->
                                </div>

                                <div class="form-group">
                                    <div class="d-inline-flex align-center" style="flex-wrap:wrap; margin-bottom:1rem;">
                                        <!-- ko ifnot: isBrandOwner() -->
                                            ${TagDefaultsHelper.getUseTagDefaultHtml(
                                              "bannerImage"
                                            )}
                                        <!-- /ko -->
                                        <label style="display:inline-block; margin-bottom:0" class="form-label icon i-brand-filled"
                                            data-bind="css: { 'default-value': isBrandOwner() || useTagDefaults().bannerImage }"
                                        >
                                            Banner
                                        </label>
                                    </div>
                                    <!-- ko if: isBrandOwner() -->
                                        <div class="w-img icon-img">
                                            <div class="d-inline-flex align-center" style="width:100%; gap:4px;">
                                                <button class="btn icon i-brand-filled only-icon" type="button" data-bind="event: { click: onClickEditBannerImage }" ></button>
                                                <!-- ko if: tagDefaults().bannerImage !== null -->
                                                    <button class="btn icon i-delete only-icon" data-bind="event: { click: onClickClearBannerImage }"></button>
                                                <!-- /ko -->
                                            </div>
                                            <!-- ko if: tagDefaults().bannerImage !== null -->
                                                <img data-bind="attr: {src: tagDefaults().bannerImage.url }" style:"width: 10rem;">
                                            <!-- /ko -->
                                        </div>
                                    <!-- /ko -->
                                    <!-- ko ifnot: isBrandOwner() -->
                                        <!-- ko ifnot: useTagDefaults().bannerImage -->
                                            <div class="w-img icon-img">
                                                <div class="d-inline-flex align-center" style="width:100%; gap:4px;">
                                                    <button class="btn icon i-brand-filled only-icon" type="button" data-bind="event: { click: onClickEditBannerImage }" ></button>
                                                    <!-- ko if: bannerImage() != null -->
                                                    <button class="btn icon i-delete only-icon" data-bind="event: { click: onClickClearBannerImage }"></button>
                                                    <!-- /ko -->
                                                </div>
                                                <!-- ko if: bannerImage() != null -->
                                                    <img data-bind="attr: {src: bannerImage().url }" style:"width: 10rem;">
                                                <!-- /ko -->
                                            </div>
                                        <!-- /ko -->
                                    <!-- /ko -->
                                </div>

                                <div class="form-group">
                                    <div class="d-inline-flex align-center" style="flex-wrap:wrap; margin-bottom:1rem;">
                                        <!-- ko ifnot: isBrandOwner() -->
                                            ${TagDefaultsHelper.getUseTagDefaultHtml(
                                              "imageGroup"
                                            )}
                                        <!-- /ko -->
                                        <label for="" style="display:inline-block; margin-bottom:0" class="form-label icon i-gallery"
                                            data-bind="css: { 'default-value': isBrandOwner() || useTagDefaults().imageGroup}"
                                        >
                                            Image Group
                                        </label>
                                    </div>
                                    <!-- ko if: isBrandOwner() -->
                                        ${this.imageWidgetForTagImageGroup.getHtmlBuild()}
                                    <!-- /ko -->
                                    <!-- ko ifnot: isBrandOwner() -->
                                        <!-- ko ifnot: useTagDefaults().imageGroup -->
                                            ${this.imageWidgetForTagImageGroup.getHtmlBuild()}
                                        <!-- /ko -->
                                    <!-- /ko -->
                                </div>

                                <div class="form-group tag-video">
                                    <label for="" class="form-label icon i-video" style="margin-bottom: 1rem;">Tag Video</label>
                                    <button class="btn-form icon i-video-2 not-selected" type="button" data-bind="event: { click: onClickSelectVideo }">Select Video</button>
                                    <!-- ko if: tagVideo -->
                                        <button class="btn icon i-delete only-icon" data-bind="event: { click: onClickRemoveVideo }"></button>
                                        <span class="form-read" data-bind="text: tagVideoTitle"></span>
                                        <div class="w-img icon-img icon i-video-2 ">
                                            <img class="i-image" data-bind="attr: { src: tagVideoThumbnailURL, alt: tagVideoTitle }" />
                                        </div>
                                    <!-- /ko -->
                                </div>

                                <div class="form-group">
                                    <label for="" class="form-label icon i-tag">Tag Name</label>
                                    <span class="form-read larger" data-bind="text: name"></span>
                                </div>
                                <div class="form-group">
                                    <label for="" class="form-label icon i-tag-type" data-bind="visible: type() != null">Tag Type</label>
                                    <span class="form-read larger" data-bind="visible: type() != null, text:  idReferenceAndTagType"></span>
                                     <!-- ko if: type() == null -->
                                        ${this.filterEditTagType.getHtmlBuild()}
                                     <!-- /ko -->
                                </div>
                                <div class="form-group">
                                    <div class="multi-row" style="flex-wrap: wrap">
                                        <input id="isSelectable" type="checkbox" data-bind="checked: isSelectable"/>
                                        <label for="isSelectable" class="form-label icon i-check">Available for use </label>
                                        <div class="w-tooltips-adv pos-bottom short" style="transform: translateY(5px);z-index: 300">
                                            ${this.selectableTagsEditPageTooltip.getHtmlBuild()}
                                        </div>
                                    </div>
                                </div>
                                <!-- ko if: isBrandOwner() -->
                                    <div class="form-group">
                                        <div class="multi-row brand-indicator">
                                            <!-- ko if: brandOwner() -->
                                                <span data-bind="attr: { class: brandOwner().iconImage + ' dark square-icon brand-owner' }"></span>
                                            <!-- /ko -->
                                            <div data-bind="text: getBrandOwnerInfoText()"></div>
                                        </div>
                                    </div>
                                <!-- /ko -->
                                <div class="form-group">
                                    <div class="d-inline-flex align-center" style="flex-wrap:wrap; margin-bottom:1rem;">
                                        <!-- ko ifnot: isBrandOwner() -->
                                            ${TagDefaultsHelper.getUseTagDefaultHtml(
                                              "tagColor"
                                            )}
                                        <!-- /ko -->
                                        <label class="form-label icon i-color"  style="display:inline-block;"
                                            data-bind="css: { 'default-value': isBrandOwner() || useTagDefaults().tagColor}">
                                            Tag Color
                                        </label>
                                    </div>
                                    <!-- ko if: isBrandOwner() -->
                                        <div class="w-input" style="display:flex; gap:.5rem; align-items: center;">
                                            <input type="text"
                                                name="tagDefaultColor"
                                                id="tagDefaultColor"
                                                class="input-text"
                                                data-bind="
                                                    value: tagDefaultColor,
                                                    enable: permissions()['tag_color']?.write,
                                                    valueUpdate: 'afterkeydown'
                                                "
                                            />
                                            <div data-bind="style: { 'background-color': tagDefaultColor() }"
                                                style="
                                                    height: calc(3rem - 2px);
                                                    width: calc(3rem - 2px);
                                                    border: 1px solid #d1d1d1;
                                                    border-radius: 10%;
                                                    display: inline-block;
                                                    margin-left: 5px;
                                                "
                                            ></div>
                                        </div>
                                    <!-- /ko -->
                                    <!-- ko ifnot: isBrandOwner() -->
                                        <!-- ko ifnot: useTagDefaults().tagColor -->
                                            <div class="w-input" style="display:flex; gap:.5rem; align-items: center;">
                                                <input type="text" name="tagColor" id="tagColor" class="input-text" data-bind="value: tagColor, enable: permissions()['tag_color']?.write, valueUpdate: 'afterkeydown'">
                                                <div data-bind="style: { 'background-color': tagColor() }"
                                                    style="
                                                        height: calc(3rem - 2px);
                                                        width: calc(3rem - 2px);
                                                        border: 1px solid #d1d1d1;
                                                        border-radius: 10%;
                                                        display: inline-block;
                                                        margin-left: 5px;
                                                    "
                                                ></div>
                                            </div>
                                        <!-- /ko -->
                                    <!-- /ko -->
                                </div>

                                <!-- ko if: permissions()['vignettes'].write -->
                                    <div class="form-group">
                                        <div class="d-inline-flex align-center" style="flex-wrap:wrap; margin-bottom:1rem;">
                                            <!-- ko ifnot: isBrandOwner() -->
                                                ${TagDefaultsHelper.getUseTagDefaultHtml(
                                                  "vignette"
                                                )}
                                            <!-- /ko -->
                                            <label style="display:inline-block;" class="form-label icon i-color"
                                                data-bind="css: { 'default-value': isBrandOwner() || useTagDefaults().vignette }"
                                            >
                                                Vignette
                                            </label>
                                        </div>
                                        <!-- ko if: isBrandOwner() -->
                                            <div class="vignette">
                                                ${this.defaultVignetteFilter.getHtmlBuild()}
                                            </div>
                                            <div class="w-img w-vignette" style="right: -680px;top: -252px;display:none;">
                                                ${this.defaultVignettePreview.getHtmlBuild()}
                                                <button class="btn icon only-icon i-close hide-text close" style="position: fixed;top: 6rem;right: 3rem; display: none" type="button" ><span>close</span></button>
                                            </div>
                                            <button class="btn icon only-icon i-view view" style="width: 100%; display: none;" data-bind="{event: { click: onClickPreviewDefaultVignette }}">preview</button>
                                        <!-- /ko -->
                                        <!-- ko ifnot: isBrandOwner() -->
                                            <button class="btn icon only-icon i-close hide-text close" style="position: fixed;top: 6rem;right: 3rem; display: none" type="button" ><span>close</span></button>
                                            <!-- ko if: !useTagDefaults().vignette -->
                                                <div class="vignette">
                                                    ${this.vignetteFilter.getHtmlBuild()}
                                                </div>
                                                <div class="w-img w-vignette" style="right: -680px;top: -252px;display:none;">
                                                    ${this.vignettePreview.getHtmlBuild()}
                                                    <button class="btn icon only-icon i-close hide-text close" style="position: fixed;top: 6rem;right: 3rem; display: none" type="button" ><span>close</span></button>
                                                </div>
                                                <button class="btn icon only-icon i-view view" style="width: 100%; display: none" >preview</button>
                                            <!-- /ko -->
                                        <!-- /ko -->
                                    </div>
                                <!-- /ko -->
                            </div>
                            <div class="tag-header-right">

                                <div class="tag-header-right-row">
                                    <div class="form-group">
                                        <label for="" class="form-label icon i-tag">Tag Name</label>
                                        <span class="form-read larger" data-bind="text: name"></span>
                                    </div>
                                </div>

                                <div class="tag-header-right-row">
                                    <div class="form-group">
                                        <label for="" class="form-label icon i-tag-type" data-bind="visible: type() != null">Tag Type</label>
                                        <span class="form-read larger" data-bind="visible: type() != null, text:  idReferenceAndTagType"></span>
                                        <!-- ko if: type() == null -->
                                            ${this.filterEditTagType.getHtmlBuild()}
                                        <!-- /ko -->
                                    </div>
                                </div>

                                <div class="form-group">
                                    <hr class="form-hr" style="margin-top:0;"/>
                                </div>

                                <div class="tag-header-right-row">
                                    <div class="form-group">
                                        <div class="d-inline-flex align-center" style="flex-wrap:wrap; margin-bottom:1rem;">
                                            <label  style="display:inline-block; margin-bottom:0" class="form-label"
                                                style="display:inline-flex"
                                                data-bind="css: { 'default-value': isBrandOwner() || useTagDefaults().description}"
                                            >
                                                Description
                                            </label>
                                        </div>
                                        <!-- ko ifnot: isBrandOwner() -->
                                            <textarea id="tag_description"
                                                data-bind="
                                                    value: description,
                                                    visible: !useTagDefaults().description
                                                "
                                            ></textarea>
                                        <!-- /ko -->
                                        <!-- ko if: isBrandOwner() -->
                                            <textarea id="tag_description"
                                                data-bind="value: tagDefaults().description"
                                            ></textarea>
                                        <!-- /ko -->
                                    </div>
                                </div>

                                <div class="tag-header-right-row">

                                    <div class="form-group">
                                        <div class="d-inline-flex align-center" style="flex-wrap:wrap; margin-bottom:1rem;">
                                        <label style="display:inline-block; margin-bottom:0" class="form-label"
                                            style="display:inline-flex"
                                            data-bind="css: { 'default-value': isBrandOwner() || useTagDefaults().shortDescription}"
                                        >
                                            Seo Description
                                        </label>
                                        </div>
                                        <!-- ko ifnot: isBrandOwner() -->
                                            <!-- ko ifnot: useTagDefaults().shortDescription -->
                                                <textarea data-bind="value: seoDescription"></textarea>
                                            <!-- /ko -->
                                        <!-- /ko -->
                                        <!-- ko if: isBrandOwner() -->
                                            <textarea data-bind="value: tagDefaults().shortDescription"></textarea>
                                        <!-- /ko -->
                                    </div>
                                </div>

                                <div class="form-group">
                                    <!-- ko if: embargoPermissions().write || (!embargoPermissions().write && !reviewScoreIsUnderEmbargo()) -->
                                    <div class="row rating">
                                        <label for="reviewScore" class="form-label">Review Score</label>
                                        <input id="reviewScore" class="input-text number" type="number" step="0.1" min="0.1" max="10" placeholder="X.X" data-bind="value: reviewScore" >
                                        <span>/ 10</span>
                                        <button class="btn" type="button" data-bind="visible: showAutoCalculateReviewScore,event: { click: onClickAutoCalculateReviewScore }">Auto-calculate</button>
                                    </div>
                                    <!-- /ko -->
                                </div>
                                <div class="form-group row">

                                    <!-- ko if: !embargoPermissions().write && reviewScoreIsUnderEmbargo() -->
                                    <div data-bind="text : 'Score Under Embargo Until ' + reviewScoreEmbargoEndDate.singleDatePicker() " ></div>
                                    <!-- /ko -->

                                    <!-- ko if: embargoPermissions().write -->
                                    <div>
                                        <input type="checkbox" data-bind="checked: reviewScoreIsUnderEmbargo, event : { change : onChangeSetReviewScoreEmbargoEndDate  }" id="review_score_under_embargo">
                                        <label for="review_score_under_embargo" class="form-label icon i-check" style="line-height: 1.3;">Review Score Under Embargo</label>
                                    </div>
                                    <div class="d-flex" data-bind="hidden:!reviewScoreIsUnderEmbargo()">
                                        <label class="form-label" style="margin: 1.2em 1em 0 0">Review Score Under Embargo End Date</label>
                                        ${this.reviewScoreEmbargoEndDate.getHtmlBuild()}
                                    </div>

                                    <!-- /ko -->
                                </div>

                                <div class="form-group">
                                    <hr class="form-hr" />
                                </div>

                                <div class="tag-header-right-row affiliate-link">
                                    <div class="form-group" style="display: flex; flex-wrap: wrap; row-gap: 1rem; align-items: center; border: 0;">
                                        <div class="d-inline-flex align-center" style="flex-wrap:wrap; margin-bottom:1rem;">
                                        <!-- ko ifnot: isBrandOwner() -->
                                            ${TagDefaultsHelper.getUseTagDefaultHtml(
                                              "affiliateLinks"
                                            )}
                                        <!-- /ko -->
                                        <label class="form-label" style="margin: 0"
                                            data-bind="css: { 'default-value': isBrandOwner() || useTagDefaults().affiliateLinks}"
                                        >
                                            Links
                                        </label>
                                        <!-- ko if: !useTagDefaults().affiliateLinks || isBrandOwner() -->
                                            <button class="btn only-icon icon i-plus " type="button" data-bind="event: { click: onClickShowAffiliateLink }"></button>
                                        <!-- /ko -->
                                        </div>
                                    </div>
                                </div>

                                <!-- ko if: isBrandOwner() -->
                                    <div class="tag-header-right-row affiliate-link">
                                        <div class="form-group affiliate-list">
                                            ${this.getDefaultAffiliateLinksHtml()}
                                        </div>
                                    </div>
                                    <!--<div class="tag-header-right-row affiliate-link default-value">
                                        <div class="form-group" data-bind="visible: defaultsHaveStreamRentBuyLinks">
                                          <label class="form-label" data-bind="html: streamRentBuyString"></label>
                                        </div>
                                    </div>-->
                                <!-- /ko -->
                                <!-- ko ifnot: isBrandOwner() -->
                                    <!-- ko ifnot: useTagDefaults().affiliateLinks -->
                                        <div class="tag-header-right-row affiliate-link">
                                            <div class="form-group affiliate-list">
                                                ${this.getAffiliateLinksHtml()}
                                            </div>
                                        </div>
                                    <!-- /ko -->
                                <!-- /ko -->

                                <div class="form-group">
                                    <hr class="form-hr" />
                                </div>

                                <!-- ko if: !useTagDefaults().affiliateLinks || isBrandOwner() -->
                                <div class="tag-header-right-row affiliate-link">
                                    <div class="form-group" class="d-flex" style="align-items: center;border: 0;">
                                        <div class="d-inline-flex align-center" style="flex-wrap:wrap; margin-bottom:1rem;">
                                        <label class="form-label" style="margin: 0">Advanced Links</label>
                                        <!-- ko if: !useTagDefaults().affiliateLinks || isBrandOwner() -->
                                            <button class="btn only-icon icon i-plus " type="button" data-bind="event: { click: onClickShowAffiliateOptionLink }"></button>
                                        <!-- /ko -->
                                        </div>
                                    </div>
                                </div>

                                <div class="tag-header-right-row affiliate-link">
                                    <!-- id="affiliate_option_links_section" -->
                                    <div class="form-group affiliate-list">
                                        <!-- ko if: streamRentBuyLinks != null -->
                                          <div class="" data-bind="visible: (defaultsHaveStreamRentBuyLinks || hasStreamRentBuyLinks)">
                                            <label class="form-label" data-bind="html: streamRentBuyString"></label>
                                          </div>
                                        <!-- /ko -->
                                        <div class="affiliate-options-list">
                                        <!-- ko if: automaticDefault() || (affiliateLinks() === null || affiliateLinks().length <= 0) -->
                                        <!-- ko foreach: affiliateOptionLinks -->
                                            ${this.getAffiliateOptionsLinksHtml()}
                                            <!-- /ko -->
                                        <!-- /ko -->
                                        <!-- ko ifnot: (automaticDefault() || (affiliateLinks() === null || affiliateLinks().length <= 0)) -->
                                            <!-- ko if: !useTagDefaults().affiliateLinks -->
                                                <!-- ko foreach: affiliateOptionLinks -->
                                                    ${this.getAffiliateOptionsLinksHtml()}
                                                <!-- /ko -->
                                            <!-- /ko -->
                                        <!-- /ko -->
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <hr class="form-hr" />
                                </div>
                                <!-- /ko -->

                            <!-- ko if: providerRelationships().length > 0 && isBrandOwner() -->
                                <div class="tag-header-right-row">
                                    <div class="form-group">
                                        <div><strong class="form-sub-title">Providers</strong></div>
                                        <!-- ko foreach: providerRelationships -->
                                        <div class="d-inline-flex align-center" style="flex-wrap:wrap;">
                                            <span style="transform: translateY(-3px);margin-right: 0.5rem;" class="icon i-cloud"></span>
                                            <label data-bind="text: providerName" class="form-label"></label>
                                            <!-- ko if: $data.infoButton -->
                                            <div class="w-tooltips-adv short pos-right" data-bind="template: { name: 'infoButton-template', data: $data.infoButton.getTemplateViewModel() }" style="transform: translateY(2px);z-index: 300"></div>
                                            <!-- /ko -->
                                        </div>
                                        <input type="text" data-bind="value: idProviderReference, valueUpdate: 'afterkeydown'" class="input-text" />
                                        <!-- /ko -->
                                    </div>
                                </div>
                            <!-- /ko -->
                            </div>
                        </div>
                        <div class="tag-body">
                            ${this.tagTypeFieldEdit.getHtmlBuild()}
                            <hr>
                            <div class="form-group">
                                <strong class="section-title">Specifications</strong>
                                <!-- ko if: canAddSpec() -->
                                <button class="btn only-icon icon i-plus" type="button" data-bind="event: { click: onClickAddSpec }" ><span class="hidden-text">add specification</span></button>
                                <!-- /ko -->
                            </div>
                            <div class="form-group spec spec-edit" data-bind="foreach: specs">
                                <!-- ko if: dataType != 'images' && dataType != 'listtag' && !$parent.isDataTypeJSON(dataType) -->
                                <div class="form-col">
                                    <div class="form-row"
                                        data-bind="
                                            css: {
                                                'two-buttons': (fieldId == null && (dataType != 'text' || dataType == 'currency' || dataType == 'number' || dataType == 'rating')),
                                                'one-button': (((fieldId != null && dataType != 'text') || (fieldId == null && dataType == 'text')) ) && dataType != 'rating',
                                                'default-value': $parent.computedShowDefaultValue().indexOf(fieldId) >= 0
                                            }
                                        "
                                    > 
                                        <i class="icon i-cloud" data-bind="visible: isProvider"></i>
                                        <label class="icon has-icon form-label"
                                            data-bind="
                                                css: {
                                                    'i-tag': (dataType == 'tag' || dataType == 'tags'),
                                                    'i-recat-log': dataType =='text',
                                                    'i-calendar-b': dataType =='date',
                                                    'i-article': dataType =='rich text',
                                                    'i-currency': dataType == 'currency',
                                                    'i-number': dataType == 'number' || dataType == 'rating'
                                                }
                                            "
                                        >
                                            <span data-bind="
                                                text: (dataType == 'rating') ? (label + '  - /' + ratingScale) : label"
                                            ></span>
                                        </label>

                                        <div class="input-wrapper">
                                            ${this.getOverrideValueHtml()}
                                        </div>

                                    </div>
                                </div>
                                <!-- /ko -->
                            </div>
                        </div>
                    </div>
                    <div class="form-footer">
                        <button type="button" class="btn " data-bind="event: { click: onClickCancel }">Cancel</button>
                        <button type="button" class="btn highlight"  data-bind="event: { click: onClickSave }">Save</button>
                    </div>
                </div>
            </div>

            <div class="w-lightbox light-theme" data-bind="css: { 'is-visible': isAffiliateLinksFormShown }">
                <div class="lightbox-content">
                    <div class="w-form lightbox-form" style="width:50rem;">
                        <div class="form-header">
                            <h3 class="form-title">Add Affiliate link</h3>
                            <button type="button" class="close-button icon i-close-2" data-bind="event: {click: onClickCancelAffiliateLink }"></button>
                        </div>

                        <div class="form-body">
                            <div class="form-group alert-message error" data-bind="visible: affiliateLinkError">
                              <i class="icon i-notice-alert"></i>
                              <span><strong>Error: </strong><span data-bind="text: affiliateLinkError"></span></span>
                            </div>
                            <div class="form-group">
                                ${this.filterAffiliates.getHtmlBuild()}
                            </div>
                            <div class="form-group row form-check-inline"  data-bind="visible: isAutoLinkerEnabled">
                                <input id="autoAffiliateEmakiAutolinker" type="checkbox" data-bind="checked: autoAffiliateEmakiAutolinker">
                                <label for="autoAffiliateEmakiAutolinker" class="icon i-check">Auto-Affiliate With Emaki Autolinker</label>
                            </div>
                            <div class="form-group row form-check-inline" data-bind="visible: isAutoLinkerThirdPartyServiceEnabled">
                                <input id="autoAffiliateThirdPartyService" type="checkbox" data-bind="checked: autoAffiliateThirdPartyService">
                                <label for="autoAffiliateThirdPartyService" class="icon i-check">Auto-Affiliate With Third Party Affiliation Services</label>
                            </div>
                            <div class="form-group row form-check-inline" data-bind="visible: affiliateAutomaticPricingAvailable">
                                <input id="automatic-pricing" type="checkbox" data-bind="checked: affiliateAutomaticPricing">
                                <label for="automatic-pricing" class="icon i-check">automatic pricing</label>
                                <div class="w-tooltips-adv pos-top short" style="top: 0.5em;position: relative;">
                                    ${this.automaticPricingTooltip.getHtmlBuild()}
                                </div>
                            </div>
                            <div class="form-group row" data-bind="visible: !affiliateAutomaticPricingAvailable() || !affiliateAutomaticPricing()">
                                <label for="" class="form-label">sale price</label>
                                <div style="display: flex;align-items: center">
                                    <span class="form-label" style="margin-right: .5rem">$</span>
                                    <input class="input-text number"  data-bind="value: affiliateSalePrice" type="number">

                                </div>
                            </div>
                            <div class="form-group row" data-bind="visible: !affiliateAutomaticPricingAvailable() || !affiliateAutomaticPricing()">
                                <label for="" class="form-label">full price</label>
                                <div style="display: flex;align-items: center">
                                    <span class="form-label" style="margin-right: .5rem">$</span>
                                    <input class="input-text number"  data-bind="value: affiliatePrice" type="number">
                                </div>
                            </div>
                            <div class="form-group inside-label">
                                    <label for="" class="form-label">url</label>
                                    <input class="input-text" data-bind="value: affiliateUrl" type="text">
                            </div>
                            <div class="form-group row">
                                    <label for="" class="form-label">expiration</label>
                                    <select name="" id="" data-bind="value: affiliateExpirationOption">
                                        <option value="1">None</option>
                                        <option value="2">Now</option>
                                        <option value="3">Scheduled</option>
                                    </select>
                            </div>
                            <div class="form-group" data-bind="visible: affiliateExpirationOption() == 3">
                                <!--<label for="" class="form-label">expiration</label>-->
                                ${this.linkExpirationDatePicker.getHtmlBuild()}
                            </div>
                            <div class="form-group inside-label">
                                    <label for="" class="form-label">link text override</label>
                                    <input class="input-text"  data-bind="value: affiliateLinkTextOverride" type="text">
                            </div>
                            <div class="form-group inside-label" data-bind="visible: defaultsHaveStreamRentBuyLinks && isAffiliateLinksFormAdvancedVisible">
                              ${this.filterLocales.getHtmlBuild()}
                            </div>
                            <div class="form-group inside-label" data-bind="visible: defaultsHaveStreamRentBuyLinks && isAffiliateLinksFormAdvancedVisible">
                                 <label for="" class="form-label">Option</label>
                                 <input class="input-text" data-bind="value: option" type="text">
                            </div>
                        </div>

                        <div class="form-footer">
                            <button type="button" class="btn" data-bind="event: {click: onClickCancelAffiliateLink }">Cancel</button>
                            <button type="button" class="btn highlight icon i-check" data-bind="event: {click: onClickAddAffiliateLink }">Save</button>
                        </div>
                    </div>
                </div>
            </div>
        `;
  }

  protected getAffiliateLinksHtml(): string {
    return /* html */ `
            <!-- ko if: affiliateLinks() !== null -->
                <div class="affiliate-list" data-bind="foreach: affiliateLinks , childrenComplete : handleDragAndDrop($element, affiliateLinks ,'.form-row') ">
                    ${this.getAffiliateLinkHtml()}
                </div>
            <!-- /ko -->
        `;
  }


  protected getDefaultAffiliateLinksHtml(): string {
    return /* html */ `
            <!-- ko if: tagDefaults().affiliateLinks !== null -->
                <div class="affiliate-list" data-bind="foreach: tagDefaults().affiliateLinks , childrenComplete : handleDragAndDrop($element, tagDefaults().affiliateLinks ,'.form-row') ">
                    ${this.getAffiliateLinkHtml()}
                </div>
            <!-- /ko -->
        `;
  }

  /**
   * Template code for the inner loop of affiliateLinks. Wrap with any foreach: affiliateLinks array to display.
   * @returns string
   */
  protected getAffiliateLinkHtml(): string {
    return /* html */ `
                <div class="form-row affiliate-elements" data-bind="visible: (!$data.countryCode && !$data.option)">
                    <label data-bind="text: type" class="form-label icon i-drag"></label>
                    <div>
                        <div class="afilliate-price">
                            <span class="form-read" data-bind="text: !$data.automaticPricing && $data.salePrice ? '$' + salePrice : ''"> </span>
                            <span class="form-read" data-bind="text: !$data.automaticPricing && $data.price ? '$' + price : '', css: { 'regular-price' : $data.salePrice }"> </span>
                            <span class="form-read" data-bind="text: !$data.automaticPricing && $data.price && salePrice ? 'Save $' + (Math.round((price - salePrice) * 100) / 100)  : ''"> </span>
                            <span class="form-read" style="position:relative;left:-.75em;" data-bind="text: $data.automaticPricing ? 'Automatic Pricing' : ''"> </span>
                        </div>
                        <a target="_blank" data-bind="attr: { id : 'link-preview-' + $data.id, href : value}, text : value.substr(0,30) + '...'" ></a>
                    </div>
                    <div style="display: flex">
                        <button class="btn only-icon icon i-edit" data-bind="event: { click: $parent.onClickEditLink }"><span class="hidden-text">edit</span></button>
                        <button class="btn only-icon icon i-cross" type="button" data-bind="event: { click: $parent.onClickDeleteLink }"><span class="hidden-text">delete</span></button>
                    </div>
                </div>
            `;
  }


  protected getAffiliateOptionsLinksHtml(): string {
    return /* html */ `
      <div class="form-row drag-element" data-bind="visible: $data.option">
        <label data-bind="text: type" class="form-label icon i-drag"></label>
        <div class="afilliate-price" style="display: flex;flex-direction: column;">
          <span class=""><a target="_blank" data-bind="attr: { id : 'link-preview-' + $data.id, href : value}, text : value.substr(0,30)" id="site-view202761"></a></span>
          <div style="display:flex;gap:2px;">
            <span class="form-read" style="margin-top:0;flex: none;" data-bind="text: $data.option ? $data.option : ''"> </span>
            <span class="form-read" style="margin-top:0;flex: none;" data-bind="text: $data.countryCode ? $data.countryCode : ''"> </span>
          </div>
        </div>
        <div style="display: flex;">
            <button class="btn only-icon icon i-edit" data-bind="event: { click: $parent.onClickEditOptionsLink }"><span class="hidden-text">edit</span></button>
            <button class="btn only-icon icon i-cross" type="button" data-bind="event: { click: $parent.onClickDeleteLink }"><span class="hidden-text">delete</span></button>
        </div>
      </div>
      <!--<div data-bind="text: ko.toJSON($data, null, 2)"></div>-->
    `;
  }

  private onLoadTemplate() {}

  protected getOverrideValueHtml(): string {
    return /* html */ `
            <div class="d-flex">
                <!-- ko if: isDefault -->
                    <div class="input-text"
                        data-bind="
                            html: $parent.getSpecDefault(dataType, fieldId, '[CURRENTLY EMPTY]'),
                            css: { 'rich-text': dataType == 'rich text' }
                        "
                    ></div>
                <!-- /ko -->
                <!-- ko ifnot: isDefault -->
                    <!-- ko if: dataType == "rich text" -->
                        <div class="input-text rich-text"
                            type="text"
                            data-bind="
                                html: $parent.getSpecValue(dataType, fieldId),
                                disable: disabled || isDefault
                            "
                        ></div>
                    <!-- /ko -->
                    <!-- ko ifnot: dataType == "rich text" -->
                        <input class="input-text"
                            type="text"
                            data-bind="
                                value: $parent.getSpecValue(dataType, fieldId),
                                disable: disabled || isDefault,
                                event: { input: $parent.evaluateShowAutoCalculateReviewScore, input: $parent.updateSpecValue },
                                valueUpdate: 'input'
                            "
                        />
                    <!-- /ko -->
                    <!-- ko if: $parent.isSpecDataTypePopupEdit(dataType) -->
                        <div class="w-btn">
                            <button type="button"
                                class="btn-form icon icon-only i-edit"
                                data-bind="
                                    event: {click: $parent.onClickEditSpecification.bind($data, $index()) },
                                    attr: { disabled: isDefault },
                                "
                            ></button>
                        </div>
                    <!-- /ko -->
                <!-- /ko -->
                <div class="w-btn default-btn">
                    <button class="btn only-icon icon i-circle" type="button" data-bind="event: {click: $parent.onClickIsDefault.bind($data, $index()) }"><span class="hidden-text">default</span></button>
                </div>
                <div style="margin-left:0.5rem;" data-bind="visible: fieldId == null">
                    <button class="btn only-icon icon i-cross" type="button" data-bind="event: { click: $parent.onClickDeleteSpec }"><span class="hidden-text">delete</span></button>
                </div>

            </div>
        `;
  }

  protected initPartial(): void {
    const appZone = this.caller.getVnAppZone();
    this.idBrand = appZone.app.params["idBrand"];

    if(!this.idBrand){
      this.idBrand = this.caller.getBrandId();
    }
    this.localeHandler = new LocaleHandler(appZone, this.idBrand);

    this.automaticPricingTooltipContent = `
        <p>
        When checked the most up-to-date pricing will be used if it is available.
        </p>
        `;
    this.automaticPricingTooltip = new infoButton_template(
      "automaticPricingTooltip",
      this.getTemplateViewModel(),
      this.caller
    );
    this.automaticPricingTooltip.setTitle("Automatic Pricing");
    this.automaticPricingTooltip.setContent(
      this.automaticPricingTooltipContent
    );

    this.filterAffiliates = new filterAutocomplete_template(
      "filterAutocompleteTagEditAffiliate_template",
      this.getTemplateViewModel(),
      this.caller
    );
    this.filterAffiliates.setAddNewOptionEnabled(true);
    this.filterAffiliates.setNumberOfChars(1);
    this.filterAffiliates.setPlaceholder("Affiliate Partner");
    this.filterAffiliates.setOptionType("Affiliate Partner");

    this.filterLocales = new filterAutocomplete_template(
      "filterAutocompleteLocales_template",
      this.getTemplateViewModel(),
      this.caller
    );

    this.filterLocales.setAddNewOptionEnabled(false);
    this.filterLocales.setNumberOfChars(1);
    this.filterLocales.setPlaceholderAndLabel("GEO");
    this.filterLocales.setOptionType("GEO");

    this.filterEditTagType = new filterAutocomplete_template(
      "filterEditTagType",
      this.getTemplateViewModel(),
      this.caller
    );
    this.filterEditTagType.setPlaceholderAndLabel("Tag Type");
    this.filterEditTagType.setOptionType("Tag Type");
    this.filterEditTagType.setNumberOfChars(2);
    this.filterEditTagType.setAddNewOptionEnabled(false);
    this.filterEditTagType.setFilterIconCSSClass("i-tag-type-a");

    this.linkExpirationDatePicker = new filterSingleDate_template(
      "linkExpirationDatePickerEdit",
      this.getTemplateViewModel(),
      this.caller
    );
    this.linkExpirationDatePicker.setDate(
      this.getFormattedEasternTimeZoneDateTime("/")
    );

    this.tagTypeFieldEdit = new tagTypFieldEdit_template(
      "tagTypeFieldEdit",
      this.getTemplateViewModel(),
      this.caller
    );
    this.tagTypeFieldEdit.setBrand(this.caller.getBrandId());
    this.tagTypeFieldEdit.setExcludeDataTypesIds([9]);

    this.selectableTagsEditPageTooltipContent = `
        <p>
        Enabling this will allow this tag to be used by a given brand.
        </p>
        `;
    this.selectableTagsEditPageTooltip = new infoButton_template(
      "selectableTagsEditPageTooltip",
      this.getTemplateViewModel(),
      this.caller
    );
    this.selectableTagsEditPageTooltip.setTitle("Tag Selection");
    this.selectableTagsEditPageTooltip.setContent(
      this.selectableTagsEditPageTooltipContent
    );

    this.imageWidgetForTagImage = new imageWidget_template(
      "tagImageEdit",
      this.getTemplateViewModel(),
      this
    );
    this.imageWidgetForTagImage.setMode("single-select");

    this.imageWidgetForTagIconImage = new imageWidget_template(
      "tagIconImageEdit",
      this.getTemplateViewModel(),
      this
    );
    this.imageWidgetForTagIconImage.setMode("single-select");

    this.imageWidgetForTagBannerImage = new imageWidget_template(
      "tagBannerImageEdit",
      this.getTemplateViewModel(),
      this
    );
    this.imageWidgetForTagBannerImage.setMode("single-select");

    this.imageWidgetForTagImageGroup = new imageWidget_template(
      "tag_image_group",
      this.getTemplateViewModel(),
      this
    );
    this.imageWidgetForTagImageGroup.setMode("multi-select-no-gallery");

    this.vignetteFilter = new filterAutocomplete_template(
      "vignetteFilter",
      this.getTemplateViewModel(),
      this.caller
    );
    this.vignetteFilter.setPlaceholderAndLabel("Vignette");

    this.vignettePreview = new vignettePreview_template(
      "vignettePreview",
      this.getTemplateViewModel(),
      this.caller
    );

    this.defaultVignetteFilter = new filterAutocomplete_template(
      "defaultVignetteFilter",
      this.getTemplateViewModel(),
      this.caller
    );
    this.defaultVignetteFilter.setPlaceholderAndLabel("Vignette");

    this.defaultVignettePreview = new vignettePreview_template(
      "defaultVignettePreview",
      this.getTemplateViewModel(),
      this.caller
    );

    this.reviewScoreEmbargoEndDate = new filterSingleDate_template(
        "reviewScoreEmbargoEndDate",
        this.getTemplateViewModel(),
        this.caller
    );

    this.reviewScoreEmbargoEndDate.setDate(null);
  }

  protected getTemplateName(): string {
    return "tagPickerEdit-template";
  }

  protected getMainElementType(): string {
    return "div";
  }

  protected getMainElementClasses(): Array<string> {
    return [];
  }

  public getImagePickerHelper() {
    return this.caller.getImagePickerHelper();
  }

  public getLocales() {
    this.locales = this.localeHandler.locales();
    return this.locales;
  }

  public getViewModelForRequest() {
    const vm = this.getTemplateViewModel();
    const tagDefaults = vm.isBrandOwner()
      ? {
          ...vm.tagDefaults(),
          tagColor: vm.tagDefaultColor(),
          description: tagDescriptionEditor
            ? tagDescriptionEditor.getData()
            : "",
          imageGroup:
            this.imageWidgetForTagImageGroup.getSelectedImagesMarkup(),
          idVignette: this.getTemplateViewModel().idSelectedDefaultVignette(),
        }
      : {};

    // remove infoButton from providerRelationships since we don't need it there
    let providerRelationships = vm.providerRelationships();
    for (let providerRelationship of providerRelationships) {
      if (providerRelationship["infoButton"]) {
        providerRelationship["infoButton"] = null;
      }
    }

    return {
      idTag: this.getTemplateViewModel().idTag(),
      name: this.getTemplateViewModel().name(),
      type: this.getTemplateViewModel().type(),
      reviewScore: this.getTemplateViewModel().reviewScore(),
      reviewScoreIsUnderEmbargo: this.getTemplateViewModel().reviewScoreIsUnderEmbargo(),
      reviewScoreEmbargoEndDate: vm.reviewScoreEmbargoEndDate.singleDatePicker(),
      image: this.getTemplateViewModel().image(),
      color: this.getTemplateViewModel().tagColor(),
      iconImage: this.getTemplateViewModel().iconImage(),
      bannerImage: this.getTemplateViewModel().bannerImage(),
      affiliateLinks: this.getTemplateViewModel().affiliateLinks(),
      providerRelationships:
        this.getTemplateViewModel().providerRelationships(),
      specs: this.getTemplateViewModel().specs(),
      description: tagDescriptionEditor ? tagDescriptionEditor.getData() : null,
      seoDescription: this.getTemplateViewModel().seoDescription(),
      isSelectable: this.getTemplateViewModel().isSelectable(),
      tagImageGroup: this.imageWidgetForTagImageGroup.getSelectedImagesMarkup(),
      idVignette: this.getTemplateViewModel().idSelectedVignette(),
      idTagVideo: this.getTemplateViewModel().tagVideo()
        ? this.getTemplateViewModel().tagVideo().id
        : null,
      useTagDefaults: this.getTemplateViewModel().useTagDefaults(),
      tagDefaults: tagDefaults,
      isAutoLinkerEnabled: this.getTemplateViewModel().isAutoLinkerEnabled(),
      isAutoLinkerThirdPartyServiceEnabled: this.getTemplateViewModel().isAutoLinkerThirdPartyServiceEnabled(),
    };
  }

  protected buildViewModel(): any {
    //create observable array refresh function
    ko.observableArray.fn.refresh = function (item, index) {
      if (index == null) index = this["indexOf"](item);
      if (index >= 0) {
        this.splice(index, 1, ko.utils.extend({}, item)); // create new item
      }
    };

    // define the viewmodel data/ functions
    let self = this;
    let vm = {
      isShown: ko.observable(false),
      isAffiliateLinksFormShown: ko.observable(false),
      isAffiliateLinksFormAdvancedVisible: ko.observable(false),
      idTag: ko.observable(null),
      name: ko.observable(null),
      reviewScore: ko.observable(null),
      reviewScoreIsUnderEmbargo: ko.observable(false),
      type: ko.observable(null),
      tagColor: ko.observable(null),
      tagVideoThumbnailURL: ko.observable(null),
      tagVideoURL: ko.observable(null),
      tagVideoTitle: ko.observable(null),
      tagVideo: ko.observable(null),
      image: ko.observable(null),
      iconImage: ko.observable(null),
      bannerImage: ko.observable(null),
      affiliateUrl: ko.observable(null),
      isAutoLinkerEnabled: ko.observable(false),
      autoAffiliateEmakiAutolinker: ko.observable(true),
      isAutoLinkerThirdPartyServiceEnabled: ko.observable(false),
      autoAffiliateThirdPartyService: ko.observable(true),
      affiliateAutomaticPricing: ko.observable(null),
      affiliateAutomaticPricingAvailable: ko.observable(false),
      affiliateSalePrice: ko.observable(null),
      affiliatePrice: ko.observable(null),
      affiliateExpiration: ko.observable(null),
      affiliateExpirationOption: ko.observable(1),
      affiliateLinkTextOverride: ko.observable(null),
      countryCode: ko.observable(null),
      option: ko.observable(null),
      affiliateLinkError: ko.observable(null),
      linkIndex: ko.observable(null),
      affiliateLinks: ko.observableArray([]),
      affiliateOptionLinks: ko.observableArray(),
      affiliateOptionsString: ko.observable(null),
      providerRelationships: ko.observableArray([]),
      specs: ko.observableArray([]),
      description: ko.observable(null),
      groupings: ko.observableArray([]),
      seoDescription: ko.observable(null),
      permissions: ko.observableArray(
        this.initPermissions([
          "tag_edit",
          "tag_type_edit_owned",
          "vignettes",
          "tag_color",
          "article_edit_embargo",
        ])
      ),
      tempTagItemPros: ko.observable([]),
      tempTagItemCons: ko.observable([]),
      editedSpec: ko.observable(null),
      isSelectable: ko.observable(0),
      idSelectedVignette: ko.observable(null),
      idSelectedDefaultVignette: ko.observable(null),
      referenceDescription: ko.observable(null),
      idReference: ko.observable(null),
      idReferenceAndTagType: ko.observable(null),
      streamRentBuyString: ko.observable(null),
      streamRentBuyLinks: ko.pureComputed(() => {
        // Stream/rent/buy links have something in countryCode attribute and option attribute set to one of stream, rent or buy

        return self
          .getTemplateViewModel()
          .affiliateLinks()
          .filter(countryCodeFilter)
          .filter(streamRentBuyFilter);
      }),
      hasStreamRentBuyLinks: ko.pureComputed(() => {
        return self.getTemplateViewModel().streamRentBuyLinks().length > 0;
      }),
      defaultStreamRentBuyLinks: ko.pureComputed(() => {
        // Stream/rent/buy links have something in countryCode attribute and option attribute set to one of stream, rent or buy
        const defaults = self.getTemplateViewModel().tagDefaults();

        return defaults && defaults.affiliateLinks
          ? defaults.affiliateLinks
              .filter(countryCodeFilter)
              .filter(streamRentBuyFilter)
          : [];
      }),
      defaultsHaveStreamRentBuyLinks: ko.pureComputed(() => {
        return (
          self.getTemplateViewModel().defaultStreamRentBuyLinks().length > 0
        );
      }),
      tagDefaultColor: ko.observable(""),
      idBrandOwner: ko.observable(null),
      brandOwner: ko.observable(null),
      isBrandOwner: ko.pureComputed(() => {
        const brandOwnerId: number | null =
          self.getTemplateViewModel().type() &&
          self.getTemplateViewModel().type().brandOwner
            ? self.getTemplateViewModel().type().brandOwner.id
            : null;
        const currentBrandId: number | null = self.parent
          ? self.parent.getIdBrand()
          : null;

        // loose comparison here
        return brandOwnerId !== null && brandOwnerId == currentBrandId;
      }),
      automaticDefault: ko.pureComputed(
        () =>
          !self.getTemplateViewModel().brand() ||
          self.getTemplateViewModel().isBrandOwner()
      ),
      brand: ko.observable(null),
      needsConfirmation: ko.observable(null),
      hasNeedsConfirmation: ko.pureComputed(
        (): boolean => self.getTemplateViewModel().needsConfirmation() !== null
      ),
      showAutoCalculateReviewScore: ko.observable(false),
      canAddSpec: ko.pureComputed(() => self.canAddSpec()),
      isSpecDataTypePopupEdit: (specTypeName: string): boolean =>
        SPEC_NAME_POPUP_EDIT.indexOf(specTypeName) >= 0,
      updateSpecValue: (spec, event) => {
        spec.value = event.target.value;
        const valueIndex = self.getSpecIndexByFieldId(spec.fieldId);

        if (valueIndex < 0) {
          return;
        }

        const specs = self.getTemplateViewModel().specs();

        specs[valueIndex].value = spec.value;
        self.getTemplateViewModel().specs([...specs]);
      },
      updateSpecDefault: (spec, event) => {
        spec.value = event.target.value;
        const defaultIndex = self.getSpecIndexByFieldId(spec.fieldId);

        if (defaultIndex < 0) {
          return;
        }

        const specs = self.getTemplateViewModel().specs();

        specs[defaultIndex].defaultValue = spec.value;
        self.getTemplateViewModel().specs([...specs]);
      },
      getSpecDefault: (
        dataType: string,
        idField: number,
        optionalMessageWhenEmpty: string | null
      ): string | null => {
        dataType = dataType.toLowerCase();
        // use to display the default
        const defaultIndex = self.getSpecIndexByFieldId(idField);

        if (defaultIndex < 0) {
          return optionalMessageWhenEmpty;
        }

        const record = self.getTemplateViewModel().specs()[defaultIndex];

        if (
          !record.defaultValue ||
          (Array.isArray(record.defaultValue) &&
            record.defaultValue.length == 0)
        ) {
          return optionalMessageWhenEmpty;
        }

        return record.defaultValue;
      },
      getSpecValue: (
        dataType: string,
        idField: number,
        optionalMessageWhenEmpty: string | null
      ): string | null => {
        if (optionalMessageWhenEmpty === null) {
          optionalMessageWhenEmpty = " ";
        }
        dataType = dataType.toLowerCase();
        // use to display the default
        const defaultIndex = self.getSpecIndexByFieldId(idField);

        if (defaultIndex < 0) {
          return optionalMessageWhenEmpty;
        }

        const record = self.getTemplateViewModel().specs()[defaultIndex];

        if (!record.value) {
          return optionalMessageWhenEmpty;
        }

        if (dataType == 'images') {

            if (record.value !== null && Array.isArray(record.value) && record.value.length > 0) {
                return (record.value.length === 1) ? "1 image in group" : record.value.length + " images in group";
            }
        }

        return record.value;
      },
      buildAffiliateOptionsString: function () {
        let optionNames = [];
          const streamLinks = TagDefaultsHelper.getAffiliateLinks(self.getTemplateViewModel());
          for (let sl in streamLinks) {
            if (streamLinks[sl].option && streamLinks[sl].option != "" && optionNames.filter(name => name.name.toLowerCase() === streamLinks[sl].option.toLowerCase()).length == 0) {
              optionNames.push({name: streamLinks[sl].option, count: 1});
            } else if (streamLinks[sl].option && streamLinks[sl].option != "" && optionNames.filter(name => name.name.toLowerCase() === streamLinks[sl].option.toLowerCase()).length >= 0) {
              optionNames.filter(name => name.name.toLowerCase() === streamLinks[sl].option.toLowerCase())[0].count++;
            }
          }

          if (optionNames.length <= 0) {
            return "";
          }

          let optionString = "Contains ";

          for (let on in optionNames) {
            optionString += "<span style=\"padding-bottom: 0;transform: none;\">" + optionNames[on].count + " " + optionNames[on].name + " / </span>";
          }

          return optionString.slice(0, optionString.length - 9) + "</span> Option Links";
      },
      getAffiliateOptionsList: function () {
        return TagDefaultsHelper.getAffiliateLinks(self.getTemplateViewModel());
      },

      onClickCancel: function (data, event) {
        self.onClickCancel(data);
      },
      onLoadTemplate: function (data, event) {
        self.onLoadTemplate();
      },
      onClickSave: function (data, event) {
        self.onClickSave(data);
      },
      onClickDeleteLink: function (data, event) {
        self.onClickDeleteLink(data);
      },
      onClickEditOptionsLink: function (data, event) {
        self.onClickEditLink(data, true);
      },
      onClickEditLink: function (data, event) {
        self.onClickEditLink(data);
      },
      onClickEditImage: function (data, event) {
        self.onClickEditImage();
      },
      onClickEditIconImage: function (data, event) {
        self.onClickEditIconImage();
      },
      onClickEditBannerImage: function (data, event) {
        self.onClickEditBannerImage();
      },
      onClickSelectVideo: function (data, event) {
        self.onClickSelectVideo();
      },
      onClickRemoveVideo: function (data, event) {
        self.onClickRemoveVideo();
      },
      onClickDeleteSpec: function (data, event) {
        self.onClickDeleteSpec(data);
      },
      onClickAddSpec: function (data, event) {
        self.onClickAddSpec();
      },
      onClickAddAffiliateLink: function (data, event) {
        self.onClickAddAffiliateLink();
      },
      onClickCancelAffiliateLink: function (data, event) {
        self.onClickCancelAffiliateLink();
      },
      onClickShowAffiliateOptionLink: function (data, event) {
        self.onClickShowAffiliateLink(true);
      },
      onClickShowAffiliateLink: function (data, event) {
        self.onClickShowAffiliateLink();
      },
      onClickclearImage: function (data, event) {
        self.onClickclearImage();
      },
      onClickClearBannerImage: function (data, event) {
        self.onClickClearBannerImage();
      },
      onClickclearIconImage: function (data, event) {
        self.onClickclearIconImage();
      },
      handleDragAndDrop: function (
        element,
        currentObservableArray,
        childrenSelector
      ) {
        self.handleDragAndDrop(
          element,
          currentObservableArray,
          childrenSelector
        );
      },
      onClickEditSpecification: function (index, spec, _event) {
        self.onClickEditSpecification(index, spec);
      },
      onClickAutoCalculateReviewScore: function (data, event) {
        self.onClickAutoCalculateReviewScore(data);
      },
      evaluateShowAutoCalculateReviewScore: function () {
        self.evaluateShowAutoCalculateReviewScore();
      },
      onClickIsDefault: function (specIndex, spec, _event): boolean {
        // why it sends the click event veriables backwards, I have no idea
        return self.onClickIsDefault(spec, specIndex);
      },
      isDataTypeJSON: function (
        dataType: string
      ): boolean {
        return dataType.endsWith("JSON");
      },
      computedShowDefaultValue: ko.pureComputed(() =>
        self
          .getTemplateViewModel()
          .specs()
          .filter((spec) => !!spec.isDefault)
          .map((spec) => spec.fieldId)
      ),
      onClickUseDefaultTagValue: function (data, event) {
          TagDefaultsHelper.onClickUseDefaultTagValue(
            data,
            event,
            self.getTemplateViewModel());
            self.getTemplateViewModel().affiliateOptionLinks(self.getTemplateViewModel().getAffiliateOptionsList());
            self.getTemplateViewModel().affiliateOptionsString(self.getTemplateViewModel().buildAffiliateOptionsString());
      },
      ...TagDefaultsHelper.viewModelProperties,
      affiliateLinksSummary: (affiliateLinks) =>
        self.getTemplateViewModel()
          ? TagDefaultsHelper.affiliateLinksSummary(
              affiliateLinks,
              self.getTemplateViewModel().defaultsHaveStreamRentBuyLinks()
            )
          : null,
      imageGroupSummary: (imageGroup) =>
        TagDefaultsHelper.imageGroupSummary(imageGroup),
      getBrandOwnerInfoText: () =>
        TagDefaultsHelper.getBrandOwnerInfoText(
          self.getTemplateViewModel().brandOwner()
        ),
      onClickPreviewDefaultVignette: () =>
        TagDefaultsHelper.onClickPreviewDefaultVignette(
          self.getTemplateViewModel()
        ),
      onClickClosePreviewDefaultVignette: () =>
        TagDefaultsHelper.onClickClosePreviewDefaultVignette(
          self.getTemplateViewModel()
        ),

      onChangeSetReviewScoreEmbargoEndDate: function (data, event){
        self.onChangeSetReviewScoreEmbargoEndDate(data, event);
      },
    };

    // need this, as the properties of tagDefaults don't seem to be reactive to changes. This determines the color preview background.
    vm.tagDefaults.subscribe((newValue, oldValue) => {
      if (oldValue === undefined || newValue.tagColor !== oldValue.tagColor) {
        vm.tagDefaultColor(newValue.tagColor);
      }
    });

    vm.useTagDefaults.subscribe((newValue) => {
      if (vm.isBrandOwner()) {
        this.initTagDescriptionEditor();
      } else {
        if (!newValue.description) {
          this.initTagDescriptionEditor();
        } else {
          for (let name in CKEDITOR.instances) {
            if (name === "tag_description") {
              CKEDITOR.instances[name].destroy(true);
              tagDescriptionEditor = null;
            }
          }
        }
      }
    });

    const embargoPermissions = ko.pureComputed(() => {
      const permissions = vm.permissions()["article_edit_embargo"];
      const { read = false, write = false } = permissions || {};
      return { read, write };
    });

    return {...vm, embargoPermissions};
  }

  protected getSpecIndexByFieldId(fieldId: number): number {
    return this.getTemplateViewModel()
      .specs()
      .findIndex((spec) => fieldId === spec.fieldId);
  }

  protected onClickIsDefault(spec: any, specIndex: number): boolean {
    const specs = this.getTemplateViewModel().specs();
    spec.isDefault = !spec.isDefault;
    specs.splice(specIndex, 1, spec);
    this.getTemplateViewModel().specs([]);
    this.getTemplateViewModel().specs([...specs]);

    return true;
  }

  public setupUseTagDefaults(tag: Tag | null = null): void {
    const vm = this.getTemplateViewModel();

    return TagDefaultsHelper.setupUseTagDefaults(
      vm,
      this.imageWidgetForTagImage,
      this.imageWidgetForTagIconImage,
      this.imageWidgetForTagBannerImage,
      this.imageWidgetForTagImageGroup,
      tag
    );
  }

  public setParent(parent): this {
    this.parent = parent;
    this.getTemplateViewModel().brand(
      getBrandInfoFromVnAppZone(this.caller.getVnAppZone())
    );

    return this;
  }

  public setLocales(locales: Locale[]): this {
    this.getTemplateViewModel().locales = locales;

    return this;
  }

  protected canAddSpec = (): boolean => {
    const vm = this.getTemplateViewModel();
    const permChecks = [
      new PermissionCheck("tag_type_edit_owned", "write"),
      new PermissionCheck("tag_type_edit_owned", "update"),
    ];

    // can add specs from the tag picker if you're the brand owner and you have permission.
    if (
      vm.isBrandOwner() &&
      userHasPermissions(vm.permissions(), permChecks, "some")
    ) {
      return true;
    } else {
      // or there's no brand owner
      return !vm.idBrandOwner();
    }
  };

  public initTagDescriptionEditor() {
    let tagDisallowedContent = "ul,ol,li";
    //contextmenu,tabletools,tableselection
    let tagRemovePlugins = "elementspath,liststyle,image,forms,list";
    let tagToolbar = [
      [
        "Undo",
        "Redo",
        "-",
        "Link",
        "Unlink",
        "-",
        "SpecialChar",
        "ImgBtn",
        "Bold",
        "Italic",
        "Strike",
        "-",
        "LinkBtn",
      ],
    ];
    let tagEditorHeight = "160px";

    for (let name in CKEDITOR.instances) {
      if (name === "tag_description") {
        CKEDITOR.instances[name].destroy(true);
      }
    }

    if (document.getElementById("tag_description")) {
      CKEDITOR.replace("tag_description", {
        height: tagEditorHeight,
        toolbar: "MA",
        fillEmptyBlocks: false,
        extraAllowedContent: "a[rel];a[target];a[href];a[title];a(*);*[id]",
        disallowedContent: tagDisallowedContent,
        removePlugins: tagRemovePlugins,
        stylesSet: "my_styles",
        format_tags: "p;h1;h2;h3",
        format_p: {
          element: "p",
        },
        toolbar_MA: tagToolbar,
        contentsCss: [
          CKEDITOR.getUrl("contents.css"),
          "/css/cke_style_short.css?v=1.0",
        ],
      });

      //CKEDITOR.config.extraPlugins = "wordcount,notification,openlink";

      tagDescriptionEditor = CKEDITOR.instances.tag_description;
    } else {
      tagDescriptionEditor = null;
    }
  }

  public setTag(tag) {
    const vm = this.getTemplateViewModel();

    if (tag != null) {
      let vignette = null;
      let video = null;
      if (tag.details) {
        vignette = tag.details.vignette;
        vm.tagColor(tag.details.color);
        video = tag.details.video;
      } else {
        this.getTemplateViewModel().tagColor(null);
      }

      if (!video && tag.defaults && tag.defaults.video) {
        video = tag.defaults.video;
      }

      this.setTagVideo(null);
      if (video) {
        vm.tagVideo(video);
        vm.tagVideoTitle(video.title);
        vm.tagVideoURL(video.url);
        if (video.thumbnail) {
          vm.tagVideoThumbnailURL(video.thumbnail.url);
        }
      }

      vm.idTag(tag.id);
      vm.name(tag.name);

      for (let providerRelationship of tag.providerRelationships) {
        let description = providerRelationship["description"] || "";
        if (description != "") {
          this.addInfoButton(
            providerRelationship,
            providerRelationship["idProvider"],
            description
          );
        }
      }
      vm.providerRelationships(tag.providerRelationships);

      vm.description(tag.description);
      vm.seoDescription(tag.seoDescription);
      vm.reviewScore(tag.reviewScore);
      // vm.isAutoLinkerEnabled();

      vm.reviewScoreIsUnderEmbargo(tag.details.reviewScoreIsUnderEmbargo);
      this.buildEmbargoEndDateCalendar(tag.details.reviewScoreEmbargoEndDate || null)

      let affiliateLinks = JSON.parse(JSON.stringify(tag.affiliateLinks || []));
      vm.affiliateLinks(affiliateLinks);
      vm.type(null);
      vm.type(tag.type);

      vm.idBrandOwner(
        tag.type && tag.type.brandOwner ? tag.type.brandOwner.id : null
      );
      vm.brandOwner(
        tag.type && tag.type.brandOwner ? tag.type.brandOwner : null
      );

      let specs = JSON.parse(JSON.stringify(tag.allSpecs || []));

      vm.specs(specs);
      this.evaluateShowAutoCalculateReviewScore();
      vm.groupings();

      vm.tempTagItemPros(tag.pros);
      vm.tempTagItemCons(tag.cons);
      vm.isSelectable(tag.isSelectable);
      vm.isAutoLinkerEnabled(tag.isAutoLinkerEnabled || false);
      vm.isAutoLinkerThirdPartyServiceEnabled(tag.isAutoLinkerThirdPartyServiceEnabled || false);

      this.setSelectedVignette(vignette);
      this.vignetteFilter.setOption(vignette);
      this.vignettePreview.setIndexedValues(tag, tag.allSpecs || []);

      this.getTemplateViewModel().idReference(tag.idReference);
      this.getTemplateViewModel().referenceDescription(
        tag.referenceDescription
      );

      let idReferenceAndTagType = "";
      if (tag.idReference) {
        idReferenceAndTagType = `${tag.idReference} | `;
      }
      if (tag.type) {
        idReferenceAndTagType += `${tag.type.name} ${tag.type.formattedDataset}`;
      } else {
        idReferenceAndTagType += "None";
      }
      this.getTemplateViewModel().idReferenceAndTagType(idReferenceAndTagType);

      if (vm.isBrandOwner()) {
        vm.image(tag.defaults.image);
        vm.iconImage(tag.defaults.iconImage);
        vm.bannerImage(tag.defaults.bannerImage);
        // load the defaults into the image pickers for the owners
        if (tag.defaults.imageGroup) {
          let imageGroupArray = JSON.parse(tag.defaults.imageGroup);
          if (
            typeof imageGroupArray[0] !== "undefined" &&
            imageGroupArray[0].images.length > 0
          ) {
            this.imageWidgetForTagImageGroup.setSelectedImagesMarkup(
              imageGroupArray[0].source
            );
            this.imageWidgetForTagImageGroup.setSelectedImages(
              imageGroupArray[0].images
            );
          }
        }

        this.setSelectedDefaultVignette(vignette);
        this.defaultVignetteFilter.setOption(tag.defaults.vignette);
        this.defaultVignettePreview.setIndexedValues(tag, tag.allSpecs || []);
      } else {
        vm.image(tag.details.image);
        vm.iconImage(tag.details.iconImage);
        vm.bannerImage(tag.details.bannerImage);
        // load the _extras into the image pickers for the others
        if (tag.details.imageGroup) {
          let imageGroupArray = JSON.parse(tag.details.imageGroup);
          if (
            typeof imageGroupArray[0] !== "undefined" &&
            imageGroupArray[0].images.length > 0
          ) {
            this.imageWidgetForTagImageGroup.setSelectedImagesMarkup(
              imageGroupArray[0].source
            );
            this.imageWidgetForTagImageGroup.setSelectedImages(
              imageGroupArray[0].images
            );
          }
        }

        if (tag.defaults.vignette) {
          this.setSelectedDefaultVignette(tag.defaults.vignette);
          this.defaultVignettePreview.setVignette(tag.defaults.vignette);
        }
      }
      vm.tagDefaults(tag.defaults);

      TagDefaultsHelper.setupUseTagDefaults(
        vm,
        this.imageWidgetForTagImage,
        this.imageWidgetForTagIconImage,
        this.imageWidgetForTagBannerImage,
        this.imageWidgetForTagImageGroup,
        tag
      );
    } else {
      //adding new tag
      TagDefaultsHelper.setupUseTagDefaults(
        vm,
        this.imageWidgetForTagImage,
        this.imageWidgetForTagIconImage,
        this.imageWidgetForTagBannerImage,
        this.imageWidgetForTagImageGroup
      );
    }

    this.getTemplateViewModel().affiliateOptionLinks(this.getTemplateViewModel().getAffiliateOptionsList());
    this.getTemplateViewModel().streamRentBuyString(this.getTemplateViewModel().buildAffiliateOptionsString());
  }

  public setSelectedVignette(vignette) {
    let idVignette = null;

    if (vignette) {
      idVignette = vignette.id;
    }

    this.getTemplateViewModel().idSelectedVignette(idVignette);
    this.vignettePreview.setVignette(vignette);
  }

  public setSelectedDefaultVignette(vignette) {
    let idVignette = null;

    if (vignette) {
      idVignette = vignette.id;
    }

    this.getTemplateViewModel().idSelectedDefaultVignette(idVignette);
    this.defaultVignettePreview.setVignette(vignette);
  }

  protected onClickCancel(data) {
    //this.parent.hide();
    this.caller.releaseBrandTagLock(data.idTag());
  }

  public showLoading() {
    let form = document.getElementById("tag-picker-edit");
    form!.classList.add("loading");
  }

  public hideLoading() {
    let form = document.getElementById("tag-picker-edit");
    form!.classList.remove("loading");
  }

  protected onClickSave(data) {
    this.caller.saveTag({
      ...this.getViewModelForRequest(),
      pros: data.tempTagItemPros(),
      cons: data.tempTagItemCons(),
    });
  }

  public setTagImage(image) {
    if (this.getTemplateViewModel().isBrandOwner()) {
      TagDefaultsHelper.updateTagDefaultValue(
        this.getTemplateViewModel(),
        "image",
        image
      );
      TagDefaultsHelper.updateTagDefaultValue(
        this.getTemplateViewModel(),
        "idImage",
        image.id
      );
    } else {
      this.getTemplateViewModel().image(image);
    }
  }

  public setTagIconImage(image) {
    if (this.getTemplateViewModel().isBrandOwner()) {
      TagDefaultsHelper.updateTagDefaultValue(
        this.getTemplateViewModel(),
        "iconImage",
        image
      );
      TagDefaultsHelper.updateTagDefaultValue(
        this.getTemplateViewModel(),
        "idIconImage",
        image.id
      );
    } else {
      this.getTemplateViewModel().iconImage(image);
    }

    this.imageWidgetForTagIconImage.setImage(image);
  }

  public setTagBannerImage(image) {
    if (this.getTemplateViewModel().isBrandOwner()) {
      TagDefaultsHelper.updateTagDefaultValue(
        this.getTemplateViewModel(),
        "bannerImage",
        image
      );
      TagDefaultsHelper.updateTagDefaultValue(
        this.getTemplateViewModel(),
        "idBannerImage",
        image.id
      );
    } else {
      this.getTemplateViewModel().bannerImage(image);
    }

    this.imageWidgetForTagBannerImage.setImage(image);
  }

  public setGroupings(groupings) {
    this.getTemplateViewModel().groupings([]);
    this.getTemplateViewModel().groupings(groupings);
  }

  public getGroupings() {
    return this.getTemplateViewModel().groupings();
  }

  protected onClickDeleteAffiliateLink(data) {
    let affiliateLinks = TagDefaultsHelper.getAffiliateLinks(
      this.getTemplateViewModel()
    );
    affiliateLinks = affiliateLinks.filter((l) => l.id != data.id);
    TagDefaultsHelper.setAffiliateLinks(
      affiliateLinks,
      this.getTemplateViewModel()
    );
    this.getTemplateViewModel().affiliateOptionLinks(this.getTemplateViewModel().getAffiliateOptionsList());
    this.getTemplateViewModel().streamRentBuyString(this.getTemplateViewModel().buildAffiliateOptionsString());
  }

  protected onClickDeleteSpec(data) {
    let specs = this.getTemplateViewModel().specs();
    specs = specs.filter((s) => s != data);
    this.getTemplateViewModel().specs([]);
    this.getTemplateViewModel().specs(specs);
  }

  protected onClickEditImage() {
    const vm = this.getTemplateViewModel();
    let image = vm.isBrandOwner()
      ? vm.tagDefaults().image
      : this.getTemplateViewModel().image();

    if (image != null) {
      this.imageWidgetForTagImage.setImage(image);
      this.caller
        .getImagePickerHelper()
        .editImage(
          "tagImageEdit",
          "single-select",
          this.imageWidgetForTagImage
        );
    } else {
      this.caller
        .getImagePickerHelper()
        .showImagePicker(
          "single-select",
          "tagImageEdit",
          [],
          this.imageWidgetForTagImage
        );
    }
  }

  protected onClickEditIconImage() {
    const vm = this.getTemplateViewModel();
    let iconImage = vm.isBrandOwner()
      ? vm.tagDefaults().iconImage
      : this.getTemplateViewModel().iconImage();

    if (iconImage != null) {
      this.imageWidgetForTagIconImage.setImage(iconImage);
      this.caller
        .getImagePickerHelper()
        .editImage(
          "tagIconImageEdit",
          "single-select",
          this.imageWidgetForTagIconImage
        );
    } else {
      this.caller
        .getImagePickerHelper()
        .showImagePicker(
          "single-select",
          "tagIconImageEdit",
          [],
          this.imageWidgetForTagIconImage
        );
    }
  }

  protected onClickEditBannerImage() {
    const vm = this.getTemplateViewModel();
    let bannerImage = vm.isBrandOwner()
      ? vm.tagDefaults().bannerImage
      : this.getTemplateViewModel().bannerImage();

    if (bannerImage != null) {
      this.imageWidgetForTagBannerImage.setImage(bannerImage);
      this.caller
        .getImagePickerHelper()
        .editImage(
          "tagBannerImageEdit",
          "single-select",
          this.imageWidgetForTagBannerImage
        );
    } else {
      this.caller
        .getImagePickerHelper()
        .showImagePicker(
          "single-select",
          "tagBannerImageEdit",
          [],
          this.imageWidgetForTagBannerImage
        );
    }
  }

  protected onClickSelectVideo() {
    let videoPickerHelper = this.caller.getVideoPickerHelper();
    videoPickerHelper.setTarget("tagPickerEdit_tagVideo");
    videoPickerHelper.showVideoPicker();
    videoPickerHelper.getVideosData();
  }

  protected onClickRemoveVideo() {
    this.setTagVideo(null);
  }

  protected onClickclearIconImage() {
    if (this.getTemplateViewModel().isBrandOwner()) {
      TagDefaultsHelper.updateTagDefaultValue(
        this.getTemplateViewModel(),
        "iconImage",
        null
      );
    } else {
      this.getTemplateViewModel().iconImage(null);
    }
  }

  protected onClickClearBannerImage() {
    if (this.getTemplateViewModel().isBrandOwner()) {
      TagDefaultsHelper.updateTagDefaultValue(
        this.getTemplateViewModel(),
        "bannerImage",
        null
      );
    } else {
      this.getTemplateViewModel().bannerImage(null);
    }
  }

  public setTagVideo(video = null) {
    this.getTemplateViewModel().tagVideo(video);
    if (video) {
      this.getTemplateViewModel().tagVideoURL(video.url);
      this.getTemplateViewModel().tagVideoTitle(video.title);
      this.getTemplateViewModel().tagVideoThumbnailURL(video.thumbnail.url);
    } else {
      this.getTemplateViewModel().tagVideoURL(null);
      this.getTemplateViewModel().tagVideoTitle(null);
      this.getTemplateViewModel().tagVideoThumbnailURL(null);
    }
  }

  protected onClickAddSpec() {
    let type = this.getTemplateViewModel().type();
    let tagTypeId = type ? type.id : null;
    this.tagTypeFieldEdit.setGroupings(this.getGroupings());
    this.tagTypeFieldEdit.addNewTagTypeField(tagTypeId);
  }

  protected onClickShowAffiliateLink(useAdvanced = false) {
    this.resetAffiliateForm();
    this.getTemplateViewModel().linkIndex(null);
    this.getTemplateViewModel().affiliateLinkError(null);
    this.filterAffiliates.setPlaceholder("Affiliate Partner");
    this.filterAffiliates.clearEverything();
    this.getTemplateViewModel().option(null);
    this.getTemplateViewModel().isAffiliateLinksFormShown(true);
    this.getTemplateViewModel().isAffiliateLinksFormAdvancedVisible(useAdvanced);
    this.clearAutomaticPricingOptions();
  }

  protected onClickCancelAffiliateLink() {
    this.filterAffiliates.setPlaceholder("Affiliate Partner");
    this.filterAffiliates.clearEverything();
    this.getTemplateViewModel().affiliateLinkError(null);
    this.getTemplateViewModel().isAffiliateLinksFormShown(false);
    this.getTemplateViewModel().isAffiliateLinksFormAdvancedVisible(false);
    this.clearAutomaticPricingOptions();
  }

  protected onClickAddAffiliateLink() {
    let defaultPlaceholder = "Affiliate Partner";
    let noPartnerSelected = "No Partner Selected";
    let alreadyAdded = "Affiliate Partner Already Added With The Same Url";
    let affiliateUrl = this.getTemplateViewModel().affiliateUrl();
    let autoAffiliateEmakiAutolinker = this.getTemplateViewModel().autoAffiliateEmakiAutolinker();
    let autoAffiliateThirdPartyService = this.getTemplateViewModel().autoAffiliateThirdPartyService();
    let affiliateAutomaticPricing = this.getTemplateViewModel().affiliateAutomaticPricing();
    let affiliateAutomaticPricingAvailable =
      this.getTemplateViewModel().affiliateAutomaticPricingAvailable();
    let affiliateSalePrice =
      this.getTemplateViewModel().affiliateSalePrice() &&
      !affiliateAutomaticPricing
        ? Math.round(this.getTemplateViewModel().affiliateSalePrice() * 100) /
          100
        : null;
    let affiliatePrice =
      this.getTemplateViewModel().affiliatePrice() && !affiliateAutomaticPricing
        ? Math.round(this.getTemplateViewModel().affiliatePrice() * 100) / 100
        : null;
    let affiliateLinkTextOverride =
      this.getTemplateViewModel().affiliateLinkTextOverride();
    let affiliateExpirationOption =
      this.getTemplateViewModel().affiliateExpirationOption();
    let affiliateExpirationDate =
      this.getTemplateViewModel().linkExpirationDatePickerEdit.singleDatePicker();
    let linkIndex = this.getTemplateViewModel().linkIndex();

    let dateExpiration = null;

    let option = this.getTemplateViewModel().option();
    let geo = this.filterLocales.getTemplateViewModel().optionObj();
    let optionsLinks = this.getTemplateViewModel().streamRentBuyLinks();
    let optionName = this.filterAffiliates.getTemplateViewModel().newOptionName();

    if (!this.filterAffiliates.getTemplateViewModel().optionObj() && !optionName) {
      this.getTemplateViewModel().affiliateLinkError("Oops! It looks like you are missing the Affiliate Partner field.");
      return;
    }

    if (affiliateUrl === null) {
      this.getTemplateViewModel().affiliateLinkError("Oops! It looks like you are missing the URL field.");
      return;
    }

    if (this.getTemplateViewModel().isAffiliateLinksFormAdvancedVisible() && !option) {
      this.getTemplateViewModel().affiliateLinkError("Oops! It looks like you are missing the Option field.");
      return;
    }

    let optionIndex = null;

    if (affiliateExpirationOption == 2) {
      //now
      dateExpiration = this.getFormattedEasternTimeZoneDateTime("-");
    } else if (affiliateExpirationOption == 3) {
      //scheduled
      dateExpiration = affiliateExpirationDate.replaceAll("/", "-");
    }

    let affiliateLinks = TagDefaultsHelper.getAffiliateLinks(
      this.getTemplateViewModel()
    );
    let highestId = 1;
    for (let a of affiliateLinks) {
      if (a.id > highestId) {
        highestId = a.id;
      }
    }
    if (this.filterAffiliates.getTemplateViewModel().addNewSelected()) {
      let optionName = this.filterAffiliates
        .getTemplateViewModel()
        .newOptionName();

      if (optionName != "") {
        this.filterAffiliates.setPlaceholder(defaultPlaceholder);
        if (affiliateUrl != null && affiliateUrl != "") {
          let newLink = {
            id: highestId + 1,
            autoAffiliateEmakiAutolinker: autoAffiliateEmakiAutolinker,
            autoAffiliateThirdPartyService: autoAffiliateThirdPartyService,
            automaticPricing: affiliateAutomaticPricing,
            automaticPricingAvailable: affiliateAutomaticPricingAvailable,
            salePrice: affiliateSalePrice,
            price: affiliatePrice,
            linkTextOverride: affiliateLinkTextOverride,
            type: optionName,
            value: affiliateUrl,
            expirationOption: affiliateExpirationOption,
            dateExpiration: dateExpiration,
            selected: false,
            isNew: true,
            idLocale: (geo == null || geo.id == null) ? null : geo.id,
            currency: (geo == null || geo.currency == null) ? null : geo.currency,
            locale: (geo == null || geo.fullLocale == null) ? null : geo.fullLocale,
            countryCode: (geo == null || geo.countryCode == null) ? null : geo.countryCode.toUpperCase(),
            option: (option == null || option == "") ? null : option,
          };

          if (optionsLinks && option) {
            optionIndex = optionsLinks.findIndex((o) => o.id == newLink.id);
          }

          if (linkIndex != null) {
            //preserve selection
            newLink.selected = affiliateLinks[linkIndex].selected;
            affiliateLinks[linkIndex] = newLink;
            if (optionIndex >= 0 && newLink.option) {
              optionsLinks[optionIndex] = newLink;
            }
          } else {
            affiliateLinks.push(newLink);
            if (option != null) {
              optionsLinks.push(newLink);
            }
          }

          this.filterAffiliates.clearEverything();
          this.getTemplateViewModel().affiliateUrl(null);
          this.getTemplateViewModel().affiliateLinkError(null);
          this.getTemplateViewModel().isAffiliateLinksFormShown(false);
          this.getTemplateViewModel().isAffiliateLinksFormAdvancedVisible(false);
        }
      } else {
        this.filterAffiliates.setPlaceholder(noPartnerSelected);
      }
    } else if (this.filterAffiliates.getTemplateViewModel().optionObj()) {
      let affiliate = this.filterAffiliates.getTemplateViewModel().optionObj();

      if (optionsLinks && option) {
        optionIndex = optionsLinks.findIndex((o) => o.id == affiliate.id);
      }

      this.filterAffiliates.setPlaceholder(defaultPlaceholder);
      if (affiliateUrl != null && affiliateUrl != "") {
        let conflictedIndex: number | null = null;
        for (let i = 0; i < affiliateLinks.length; i++) {
          let tal = affiliateLinks[i];
          if (tal.type == affiliate.name && tal.value == affiliateUrl && this.verifyOptions(tal, {option})) {
            conflictedIndex = i;
            break;
          }
        }

        let newLink = {
          id: affiliate.id,
          autoAffiliateEmakiAutolinker: autoAffiliateEmakiAutolinker,
          autoAffiliateThirdPartyService: autoAffiliateThirdPartyService,
          automaticPricing: affiliateAutomaticPricing,
          automaticPricingAvailable: affiliateAutomaticPricingAvailable,
          salePrice: affiliateSalePrice,
          price: affiliatePrice,
          linkTextOverride: affiliateLinkTextOverride,
          geo: affiliate.geo,
          type: affiliate.name,
          store: affiliate.store,
          value: affiliateUrl,
          expirationOption: affiliateExpirationOption,
          dateExpiration: dateExpiration,
          selected: false,
          isNew: false,
          idLocale: (geo == null || geo.id == null) ? null : geo.id,
          currency: (geo == null || geo.currency == null) ? null : geo.currency,
          locale: (geo == null || geo.fullLocale == null) ? null : geo.fullLocale,
          countryCode: (geo == null || geo.countryCode == null) ? null : geo.countryCode.toUpperCase(),
          option: (option == null || option == "") ? null : option,
        };

        if (optionIndex != null && optionIndex >= 0) {
          newLink = optionsLinks[optionIndex];
          newLink.automaticPricingAvailable = affiliateAutomaticPricingAvailable;
          newLink.autoAffiliateEmakiAutolinker = autoAffiliateEmakiAutolinker;
          newLink.autoAffiliateThirdPartyService = autoAffiliateThirdPartyService;
          newLink.automaticPricing = affiliateAutomaticPricing;
          newLink.salePrice = affiliateSalePrice;
          newLink.price = affiliatePrice;
          newLink.linkTextOverride = affiliateLinkTextOverride;
          newLink.geo = affiliate.geo;
          newLink.type = affiliate.name;
          newLink.store = affiliate.store;
          newLink.value = affiliateUrl;
          newLink.expirationOption = affiliateExpirationOption;
          newLink.dateExpiration = dateExpiration;
          newLink.selected = false;
          newLink.isNew = false;
          newLink.idLocale = (geo == null || geo.id == null) ? null : geo.id,
          newLink.currency = (geo == null || geo.currency == null) ? null : geo.currency,
          newLink.locale = (geo == null || geo.fullLocale == null) ? null : geo.fullLocale,
          newLink.countryCode = (geo == null || geo.countryCode == null) ? null : geo.countryCode.toUpperCase();
          newLink.option = (option == null || option == "") ? null : option;
        }

        let resetEverything = false;
        if (linkIndex != null) {
          if (conflictedIndex != null) {
            if (conflictedIndex == linkIndex) {
              newLink.selected = affiliateLinks[linkIndex].selected;
              affiliateLinks[linkIndex] = newLink;
              if (optionIndex >= 0 && newLink.option) {
                optionsLinks[optionIndex] = newLink;
              }
              resetEverything = true;
            } else {
              this.filterAffiliates.setPlaceholder(alreadyAdded);
              this.getTemplateViewModel().affiliateLinkError(alreadyAdded);
            }
          } else {
            newLink.selected = affiliateLinks[linkIndex].selected;
            affiliateLinks[linkIndex] = newLink;
            if (optionIndex >= 0 && newLink.option) {
              optionsLinks[optionIndex] = newLink;
            }
            resetEverything = true;
          }
        } else {
          if (conflictedIndex == null) {
            affiliateLinks.push(newLink);
            if (newLink.option) {
              optionsLinks.push(newLink);
            }
            resetEverything = true;
          } else {
            this.filterAffiliates.setPlaceholder(alreadyAdded);
            this.getTemplateViewModel().affiliateLinkError(alreadyAdded);
          }
        }

        if (resetEverything == true) {
          this.filterAffiliates.clearEverything();
          this.getTemplateViewModel().affiliateUrl(null);
          this.getTemplateViewModel().affiliateLinkError(null);
          this.getTemplateViewModel().isAffiliateLinksFormShown(false);
          this.getTemplateViewModel().isAffiliateLinksFormAdvancedVisible(false);
        }
      }
    } else {
      this.filterAffiliates.setPlaceholder(noPartnerSelected);
    }

    TagDefaultsHelper.setAffiliateLinks(
      affiliateLinks,
      this.getTemplateViewModel()
    );

    this.getTemplateViewModel().affiliateOptionLinks(this.getTemplateViewModel().getAffiliateOptionsList());
    this.getTemplateViewModel().streamRentBuyString(this.getTemplateViewModel().buildAffiliateOptionsString());

  }

  public show() {
    this.filterEditTagType.clearEverything();
    this.getTemplateViewModel().isShown(true);
  }

  public hide() {
    this.getTemplateViewModel().isShown(false);
  }

  public setPermissions(permissions) {
    this.getTemplateViewModel().permissions(permissions);
  }

  public setAffiliateFilterOptions(affiliates) {
    this.filterAffiliates.setOptions(affiliates);
  }

  public setEditTagTypeOptions(tagTypes) {
    this.filterEditTagType.setOptions(tagTypes);
  }

  public setEditTagLocaleOptions(locales) {
    this.filterLocales.setOptions(locales);
  }

  public getEditTagLocales() {
    return this.localeHandler.locales();
  }

  public clearAutomaticPricingOptions() {
    this.getTemplateViewModel().affiliateAutomaticPricingAvailable(false);
    this.getTemplateViewModel().affiliateAutomaticPricing(null);
  }

  protected resetAffiliateForm() {
    this.getTemplateViewModel().affiliatePrice(null);
    this.getTemplateViewModel().autoAffiliateEmakiAutolinker(true);
    this.getTemplateViewModel().autoAffiliateThirdPartyService(true);
    this.getTemplateViewModel().affiliateAutomaticPricing(null);
    this.getTemplateViewModel().affiliateAutomaticPricingAvailable(false);
    this.getTemplateViewModel().affiliateSalePrice(null);
    this.getTemplateViewModel().affiliateUrl(null);
    this.getTemplateViewModel().affiliateLinkTextOverride(null);
    this.getTemplateViewModel().affiliateExpirationOption(1);
    this.filterAffiliates.clearEverything();
    this.filterLocales.clearEverything();
  }

  protected onClickDeleteLink(data) {
    let affiliateLinks = TagDefaultsHelper.getAffiliateLinks(
      this.getTemplateViewModel()
    );
    affiliateLinks = affiliateLinks.filter(
      (l) => l.id + "_" + l.value != data.id + "_" + data.value
    );

    TagDefaultsHelper.setAffiliateLinks(
      affiliateLinks,
      this.getTemplateViewModel()
    );
    this.getTemplateViewModel().affiliateOptionLinks(this.getTemplateViewModel().getAffiliateOptionsList());
    this.getTemplateViewModel().streamRentBuyString(this.getTemplateViewModel().buildAffiliateOptionsString());
  }

  protected onClickEditLink(link, useAdvanced = false) {
    let validAutoPricingPartnerNames =
      this.parent.getValidAutoPricingPartnerNames();
    let affiliateLinks = TagDefaultsHelper.getAffiliateLinks(
      this.getTemplateViewModel()
    );
    let linkIndex = affiliateLinks.findIndex((l) => l == link || (l.id && link.id && l.id == link.id));

    this.getTemplateViewModel().linkIndex(linkIndex);

    // get what is already manually or automatically set on the link
    let isAutomatic =
      link.automaticPricing == true ||
      link.automaticPricing == "true" ||
      link.automaticPricing == 1;
    let isLinkAutomaticAvailable =
      link.affiliateAutomaticPricingAvailable == true ||
      link.affiliateAutomaticPricingAvailable == "true" ||
      link.affiliateAutomaticPricingAvailable == 1;


    if (!link.hasOwnProperty('autoAffiliateEmakiAutolinker')) {
        link.autoAffiliateEmakiAutolinker = true;
    }

    let autoAffiliateEmakiAutolinker =
      link.autoAffiliateEmakiAutolinker == true ||
      link.autoAffiliateEmakiAutolinker == "true" ||
      link.autoAffiliateEmakiAutolinker == 1;

    if (!link.hasOwnProperty("autoAffiliateThirdPartyService")) {
      link.autoAffiliateThirdPartyService = true;
    }

    let autoAffiliateThirdPartyService =
      link.autoAffiliateThirdPartyService == true ||
      link.autoAffiliateThirdPartyService == "true" ||
      link.autoAffiliateThirdPartyService == 1;

    // whether automatic pricing is available at all from the db
    let isAutomaticAvailable =
      typeof link.type !== "undefined" &&
      validAutoPricingPartnerNames.includes(link.type);

    this.resetAffiliateForm();
    this.getTemplateViewModel().affiliatePrice(link.price);
    this.getTemplateViewModel().affiliateSalePrice(link.salePrice);
    this.getTemplateViewModel().autoAffiliateEmakiAutolinker(autoAffiliateEmakiAutolinker);
    this.getTemplateViewModel().autoAffiliateThirdPartyService(
        autoAffiliateThirdPartyService
    );
    this.getTemplateViewModel().affiliateAutomaticPricing(
      link.automaticPricing
    );
    this.getTemplateViewModel().affiliateAutomaticPricingAvailable(
      isAutomaticAvailable
    );
    this.getTemplateViewModel().affiliateLinkTextOverride(
      link.linkTextOverride
    );
    this.getTemplateViewModel().affiliateExpirationOption(1);
    this.getTemplateViewModel().affiliateUrl(link.value);

    this.getTemplateViewModel().countryCode(
      link.countryCode
    );

    this.getTemplateViewModel().option(
      link.option
    );

    this.filterAffiliates.setOption({
      name: link.type,
      id: link.id,
      showAutoPricing: isAutomatic,
      hasPricingSources: isLinkAutomaticAvailable,
      option: (link.option) ? link.option : null,
    });

    let selectedLocale = this.localeHandler.getLocaleByCountryCode(link.countryCode);

    if (selectedLocale) {
      this.filterLocales.setOption({
        name: selectedLocale.name,
        countryCode: selectedLocale.countryCode,
        idLocale: selectedLocale.id,
        currency: selectedLocale.currency,
        locale: selectedLocale.fullLocale,
      });
    }

    if (link.dateExpiration != null) {
      //check if expiry date has passed
      let currentDate = this.createEasternTimeZoneDateTime();
      let dateExpiration = new Date(link.dateExpiration);

      if (dateExpiration > currentDate) {
        //scheduled
        this.getTemplateViewModel().affiliateExpirationOption(3);
        this.linkExpirationDatePicker.setDate(
          link.dateExpiration.replaceAll("-", "/")
        );
      } else {
        //expired
        this.getTemplateViewModel().affiliateExpirationOption(2);
      }
    }

    this.getTemplateViewModel().isAffiliateLinksFormAdvancedVisible(useAdvanced);
    this.getTemplateViewModel().isAffiliateLinksFormShown(true);

  }

  private getFormattedEasternTimeZoneDateTime(delimiter): any {
    let date = this.createEasternTimeZoneDateTime();

    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    let hour = date.getHours();
    let minutes = date.getMinutes();

    return (
      year +
      delimiter +
      this.padInteger(month, 2) +
      delimiter +
      this.padInteger(day, 2) +
      " " +
      this.padInteger(hour, 2) +
      ":" +
      this.padInteger(minutes, 2)
    );
  }

  private padInteger(number: number, size: number) {
    let s = number + "";
    while (s.length < size) s = "0" + s;
    return s;
  }

  private createEasternTimeZoneDateTime(date?: Date): Date {
    if (!date) {
      date = new Date();
    }

    date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
    //checks if DST is currently being observed, adjusts offset accordingly
    let easternTimeOffset = this.isDstObserved(date) ? -240 : -300;
    date.setMinutes(date.getMinutes() + easternTimeOffset);

    return date;
  }

  protected verifyOptions(linkObject1, linkObject2) {
    if ((linkObject1.option && linkObject2.option && linkObject1.option === linkObject2.option) ||
      ((!linkObject1.option || !linkObject2.option) && !(!linkObject1.option && !linkObject2.option))) {
      return true;
    }
    return false;
  }

  public isDstObserved(date: Date) {
    let jan = new Date(date.getFullYear(), 0, 1);
    let jul = new Date(date.getFullYear(), 6, 1);
    let stdTimezoneOffset = Math.max(
      jan.getTimezoneOffset(),
      jul.getTimezoneOffset()
    );

    return date.getTimezoneOffset() < stdTimezoneOffset;
  }

  public onEditTagTypeFilter() {
    let tagType = this.filterEditTagType.getOptionObj();
    this.getTemplateViewModel().type(null);
    this.getTemplateViewModel().type(tagType);
    this.getTemplateViewModel().specs(
      this.processTagTypeFieldsToSpecs(tagType)
    );
  }

  public processTagTypeFieldsToSpecs = (tagType: emaki_tag_type) => {
    const canEditInline = (field): boolean =>
      field.dataType !== "text" &&
      field.dataType !== "currency" &&
      field.dataType !== "number" &&
      field.dataType !== "rating";

    return tagType.fields.map((field) => {
      field = {
        ...field,
        fieldId: field.id,
        value: null,
        isDefault: false,
        defaultValue: null,
        originalValue: null,
        originalDefaultValue: null,
        disabled: canEditInline(field),
      };

      delete field.id;

      return field;
    });
  };

  public onClickclearImage(): any {
    if (this.getTemplateViewModel().isBrandOwner()) {
      TagDefaultsHelper.updateTagDefaultValue(
        this.getTemplateViewModel(),
        "image",
        null
      );
      TagDefaultsHelper.updateTagDefaultValue(
        this.getTemplateViewModel(),
        "idImage",
        null
      );
    } else {
      this.getTemplateViewModel().image(null);
    }
  }

  public handleDragAndDrop(
    element,
    currentObservableArray,
    childrenSelector
  ): any {
    DragAndDropHandler.handleDragAndDrop(
      element,
      currentObservableArray,
      childrenSelector
    );
  }

  public onClickEditSpecification(index: number, selectedSpecType: any) {
    this.getTemplateViewModel().editedSpec(index);

    if (!selectedSpecType.value) selectedSpecType.value = "";

    let type: emaki_tag_type | null = this.getTemplateViewModel().type();
    let tagTypeId = type ? type.id : null;

    this.tagTypeFieldEdit.setBrandOwner(type.brandOwner);
    this.tagTypeFieldEdit.setGroupings(this.getGroupings());
    this.tagTypeFieldEdit.setTagTypeField(selectedSpecType);
    this.tagTypeFieldEdit.setTagTypeId(tagTypeId);
    this.tagTypeFieldEdit.show();
  }

  public appendSpecification(): void {
    const specification = this.tagTypeFieldEdit.getViewModelForRequest();
    const editedSpec = this.getTemplateViewModel().editedSpec();
    const specs = this.getTemplateViewModel().specs();
    const originalSpec: Spec | {} =
      editedSpec !== null ? specs[editedSpec] : {};

    if (specification.fieldId == null && editedSpec == null) {
      if (specification.dataType == "rating") {
        specification.ratingScale = specification.value;
        specification.disabled = false;
        specification.value = null;
      }

      if (
        specification.isDefault &&
        this.getTemplateViewModel().isBrandOwner()
      ) {
        specs.push({
          ...specification,
          defaultValue: specification.value,
        });
      } else {
        specs.push(specification);
      }
    } else {
      if (
        specification.isDefault &&
        this.getTemplateViewModel().isBrandOwner()
      ) {
        specification.defaultValue = specification.value;
        specification.originalDefaultValue = specification.originalValue;
        specification.value = "";
      }
      // lay the new version over top, so we don't need the whole model in the return.
      specs[editedSpec] = { ...originalSpec, ...specification };
    }

    this.getTemplateViewModel().specs(specs);
    this.resetEditedSpec();
    this.tagTypeFieldEdit.getTemplateViewModel().selectedTags([]);
    this.tagTypeFieldEdit.hide();
    this.tagTypeFieldEdit.clearErrorMessages();
  }

  public resetEditedSpec(): void {
    this.getTemplateViewModel().editedSpec(null);
  }

  public onClickAutoCalculateReviewScore(target) {
    let specs = this.getTemplateViewModel().specs();
    let totalRating = 0,
      ratingsCount = 0,
      reviewScore = 0;

    specs.forEach((spec) => {
      if (
        spec.dataType == "rating" &&
        spec.ratingScale != null &&
        spec.value != null &&
        spec.value != ""
      ) {
        totalRating += spec.value / spec.ratingScale;
        ratingsCount++;
      }
    });

    if (ratingsCount > 0) {
      reviewScore = (totalRating / ratingsCount) * 10;
      if (!isNaN(reviewScore)) {
        reviewScore = parseFloat(reviewScore.toFixed(2));
      }
    }

    this.getTemplateViewModel().reviewScore(reviewScore);
  }

  public evaluateShowAutoCalculateReviewScore() {
    const specifications = this.getTemplateViewModel().specs();
    const shouldShowAutoCalculate = specifications.some(
      (spec) =>
        spec.dataType === "rating" && spec.value !== null && spec.value !== ""
    );
    this.getTemplateViewModel().showAutoCalculateReviewScore(
      shouldShowAutoCalculate
    );
  }

  public setIsImageOptimized(val) {}

  // Adds info buttons.
  public addInfoButton(section, id, description) {
    section["infoButton"] = new infoButton_template(
      `infoButton_${id}`,
      this.getTemplateViewModel(),
      this.caller
    );
    section["infoButton"].setTitle("How to Get ID");
    section["infoButton"].setContent(`<p>${description}</p>`);
  }

  onChangeSetReviewScoreEmbargoEndDate(data, event){
    if(!this.getTemplateViewModel().reviewScoreIsUnderEmbargo()){
      this.reviewScoreEmbargoEndDate.setDate(null)
    }else{
      this.reviewScoreEmbargoEndDate.setDate(this.getFormattedEasternTimeZoneDateTime("/"))
    }
  }

  setReviewScoreEmbargoEndDate(date: string){
    this.reviewScoreEmbargoEndDate.setDate(date)
  }

  setReviewScoreIsUnderEmbargo(val: boolean){
    this.getTemplateViewModel().reviewScoreIsUnderEmbargo(val);
  }

  buildEmbargoEndDateCalendar(date: string){
    this.reviewScoreEmbargoEndDate.buildCalendar();
    this.setReviewScoreEmbargoEndDate(date);
  }
}



// WEBPACK FOOTER //
// ./js/components/templates/tagPickerEdit_template.ts